import { NotificationService } from 'src/app/shared/services/notification.service';
import { FeatureKey } from 'src/app/_models';
import { RiskanalysisService } from './../services/risk-analysis.service';
import {
  inject,
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  AfterViewInit
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItem, ConfirmationService } from 'primeng/api';
import * as _ from 'lodash';

import { Feature, Rights, SessionFeature } from './../../../_models/feature';

import { DeviationList } from '../../deviation/models/deviationList';
import { TypeOfCase, Topic } from './../models/deviation';
import { DeviationServices } from '../services/deviation.services';
import { HelperService } from 'src/app/_services/helper.service';
import { BaseServices } from 'src/app/kuba/kuba.services';
import { ValidationService } from 'src/app/kuba/shared/services/validation.service';
import { TranslateService } from '@ngx-translate/core';
import { EmployeeServices } from '../../employees/services/employee.services';
import { ActivityServices } from '../services/activities.services';
import { Table } from 'primeng/table';
import { Observable, Subscription, forkJoin } from 'rxjs';
import { FeaturesBaseServices } from '../../features/services/features-base.services';
import { DeviationListChartsComponent } from './deviation-list-charts/deviation-list-charts.component';
import { Select } from 'primeng/select';
import { DeviationFilterDto } from '../models/deviationFilterRequest';
import { PagedResponse } from '../../shared/models/pagedResponse';
import { PaginationRequest } from '../../shared/models/paginationRequest';
import { DeviationListDto } from '../models/deviationListDto';
import { DeviationListMetadata } from '../models/deviationListMetaData';
import { DeviationSubModule } from '../models/deviationSubModule';
import { BusinessSelectionDialogComponent } from '../../shared/components/business-selection-dialog/business-selection-dialog.component';
import { BlurService } from '../../../shared/services/blur.service';
import { MultiDeleteResultDto } from '../models/activities';
import { ProgressLoaderConfig } from '../../shared/components/progress-loader/progress-loader.component';
import { FilterStateService } from '../../shared/services/filter-state.service';
import { NavigationEnd } from '@angular/router';
import { DeviationQrCodeDto } from '../models/deviationQrCodeDto';
import { finalize } from 'rxjs/operators';
import { LanguageId } from 'src/app/_models/language-id.enum';

interface DropdownEvent {
  value: string | null;
}

// Updated PaginationRequest interface with sorting support
export interface PaginationRequestClass extends PaginationRequest {
  sortColumn?: string;
  sortDirection?: 'ASC' | 'DESC';
}

@Component({
  selector: 'deviationList',
  templateUrl: 'deviation-list.component.html',
  styleUrls: ['deviation-list.component.scss'],
  standalone: false
})
export class DeviationListComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  //#region variables
  deviationSubModules: DeviationSubModule[] = [];
  private subModuleLookup: Map<number, string> = new Map();
  private subModuleNames: Set<string> = new Set();

  vDepartment: SelectItem[];
  departmentIds: number[] = [];
  vModules: SelectItem[];
  showDeviationDrop: boolean = false;
  showDeviationDisabled: boolean = false;

  filteredFollowUpPersons: any[] = [];
  filteredExecutionPersons: any[] = [];
  selectedFollowUpPerson: any = null;
  selectedExecutionPerson: any = null;

  private readonly notifications = inject(NotificationService);
  @ViewChild('deviationTable', { static: false }) deviationTable: Table;
  @ViewChild('progressLoader', { static: false }) progressLoader: any;

  // Filter dropdown references
  @ViewChild('showDeviation', { static: false })
  showDeviationDropdown: Select;
  @ViewChild('caseDropdown', { static: false }) caseDropdown: Select;
  @ViewChild('topicDropdown', { static: false }) topicDropdown: Select;
  @ViewChild('subDepControl', { static: false }) subDepControl: Select;
  @ViewChild('impControl', { static: false }) impControl: Select;
  @ViewChild('depControl', { static: false }) depControl: Select;
  @ViewChild('modules', { static: false }) modulesDropdown: Select;
  @ViewChild('statusDropdown', { static: false }) statusDropdown: Select;
  @ViewChild('createdByDropdown', { static: false })
  createdByDropdown: Select;
  @ViewChild('clientDropdown', { static: false }) clientDropdown: Select;

  paginationRequest: PaginationRequestClass = {
    pageNumber: 1,
    pageSize: 10,
    sortColumn: undefined,
    sortDirection: 'ASC'
  };

  private columnMapping: { [key: string]: string } = {
    No: 'No',
    BusinessName: 'BusinessName',
    Title: 'Title',
    CreatedOn: 'CreatedOn',
    CompletedDate: 'DoneOn',
    DeadlineForPdf: 'CreatedOn',
    ChecklistName: 'Title',
    ActivityName: 'Title',
    Modules: 'Title',
    Cost: 'Title'
  };

  totalPages: number = 0;

  deviationFilterDto: DeviationFilterDto = {};
  public deviationList: DeviationListDto[];
  public deviationAllList: DeviationList[];

  public isLoadingData: boolean = false;
  private loadingSubscription: Subscription;
  public applicationId: number = BaseServices.ApplicationId;
  public portalId: number = 0;

  statuses: SelectItem[];
  Case: SelectItem[];
  Client: SelectItem[];
  ShowDeviation: SelectItem[];
  status: SelectItem[];
  followup: any[];
  Topics: SelectItem[];
  topicForm: FormGroup;
  deviationSearch: FormGroup;
  caseForm: FormGroup;
  businesses: any[];
  editTopics: any = [];
  editTypeOfCases: any = [];
  startDate: string;
  endDate: string;
  isStatusDone = false;
  isEditor: boolean;
  isAdmin: boolean;
  isPortal: boolean;
  itemsPerPage = 10;
  pageSum = 0;
  topicId: number;
  caseId: number;
  viewTopic = false;
  addtypeOfCase = false;
  viewTypeOfCase = false;
  addTopic = false;
  isShowDeptDeviation = false;
  isShowSaveButton = true;
  newButtonDisplay = true;
  userId: number;
  hasDeviationDeleteAccess = true;
  userRole: string;
  additionalData: any;
  isNameExists: boolean;
  existsAlerttext: string;
  departments: any;
  subDepartments: any;
  isTopicNameExists: boolean;
  existsTopicAlerttext: string;
  existsTypeCaseAlerttext: string;
  isTypeCaseNameExists: boolean;
  importances: any;
  totalRecords: number;
  isShowPlusbutton = true;
  createdBy: SelectItem[];
  showLoader = true;
  currentDeviation: any;
  loading = false;
  isBusinessId = false;
  isShowNewButton = false;
  rowsPerPageOptions: any = [];
  vresperson = [];
  Showloader: boolean;
  departmentList: any[];
  displayDeviation = false;
  deptFilter: any = null;
  clientFilter: any = null;
  createdToFilter: any = null;
  craetedFromFilter: any = null;
  descFilter: any = null;
  responsibleFollowUpFilter: any = null;
  responsibleExecutionFilter: any = null;
  createdByFilter: any = null;
  businessFeature: SessionFeature[];
  chartViews: string[] = ['chartType1', 'chartType2', 'chartType3'];
  currentIndex: number = 0;
  isPaused: boolean = false;

  activatedFeatureIds: number[] = [];

  noFilter: string = '';
  businessNameFilter: string = '';
  titleFilter: string = '';
  checklistNameFilter: string = '';
  activityNameFilter: string = '';
  departmentFilter: string = '';

  private filterDebounceTimer: any;

  selectedFilters: {
    topic: string | null;
    case: string | null;
    followUp: string | null;
    execution: string | null;
    department: string | null;
    subDepartment: string | null;
  } = {
    topic: null,
    case: null,
    followUp: null,
    execution: null,
    department: null,
    subDepartment: null
  };

  deviationListMetadata: DeviationListMetadata;

  @ViewChild(DeviationListChartsComponent)
  chartsComponent: DeviationListChartsComponent;
  private subscriptions: Subscription[] = [];
  isIKdeviation: boolean = false;
  isAHdeviation: boolean = false;
  isInternalControl: boolean = false;
  isproject: boolean = false;
  isothersystem: boolean = false;
  isqualitysystem: boolean = false;
  isfdv: boolean = false;
  isVehicles: boolean = false;
  isFoodSafety: boolean = false;
  isKubaControl: boolean = false;
  isFramework: boolean = false;
  isService: boolean = false;
  isKunde: boolean = false;
  isQrCode: boolean = false;
  features: SessionFeature[];
  isDeptSelected: boolean = false;

  private paginationDebounceTimerId: any = null;
  private readonly PAGINATION_DEBOUNCE_TIME_MS = 300;
  isAdminRightsForUser: boolean = false;
  isViewRightsForUser: boolean = false;

  // Business selection dialog properties
  showBusinessSelectionDialog: boolean = false;

  // Multi-select properties for deviations
  selectedDeviations: DeviationListDto[] = [];
  isAllSelected: boolean = false;
  allSelectedDeviations: Set<number> = new Set(); // Track all selected deviation IDs across pages

  // Multi-delete progress properties
  isDeletingDeviations: boolean = false;
  deletingProgress: number = 0;
  totalDeviationsToDelete: number = 0;
  estimatedTimeRemaining: number = 0;
  initialEstimatedTime: number = 0;

  // Filter visibility toggle
  showFilters: boolean = false;
  showCostColumn: boolean = false;

  // Progress loader configuration
  progressLoaderConfig: ProgressLoaderConfig = {
    isVisible: false,
    title: 'DELETING_DEVIATIONS',
    message: 'DONT_CLOSE_PAGE',
    progress: 0,
    totalItems: 0,
    estimatedTimeRemaining: 0,
    initialEstimatedTime: 0,
    showProgressBar: true,
    showTimeRemaining: true,
    showItemCount: true
  };

  // Filter state management
  private readonly FILTER_MODULE_KEY = 'followup_deviations';
  private isRestoringFilters = false;

  /**
   * constructor
   * @param deviationService {DeviationService}
   * @param route {ActivatedRoute}
   * @param confirmationService {ConfirmationService}
   */
  constructor(
    private deviationService: DeviationServices,
    private route: ActivatedRoute,
    private router: Router,
    private confirmationService: ConfirmationService,
    private _fb: FormBuilder,
    private riskanalysisService: RiskanalysisService,
    private translate: TranslateService,
    private employeeServices: EmployeeServices,
    private activityServices: ActivityServices,
    private blurService: BlurService,
    private filterStateService: FilterStateService
  ) {
    this.topicForm = this._fb.group({
      Topic: [
        '',
        [Validators.required, ValidationService.noWhitespaceValidator]
      ]
    });
    this.caseForm = this._fb.group({
      Case: ['', [Validators.required, ValidationService.noWhitespaceValidator]]
    });
    this.deviationSearch = this._fb.group({
      topic: [''],
      typeOfCase: []
    });
    this.userId = BaseServices.UserId;
    this.subscriptions.push(
      this.translate.stream('FILENAME').subscribe(val => {
        this.additionalData = {
          fileName: val.DEVIATION_LIST,
          header: this.translate.instant('DEVIATION_LIST'),
          businessId: BaseServices.BusinessId,
          cultureInfo: BaseServices.userCultureInfo(),
          columnNames: [
            { title: 'Deviation Number', dataKey: 'No' },
            { title: 'Title', dataKey: 'Title' },
            { title: 'Checklist Name', datakey: 'ChecklistName' },
            { title: 'Status', dataKey: 'Status' },
            { title: 'Department', dataKey: 'Department' },
            { title: 'SubDepartment', dataKey: 'SubDepartment' },
            { title: 'Topics', datakey: 'TopicName' },
            { title: 'Type of Case', datakey: 'CaseName' },
            { title: 'Deadline', dataKey: 'DeadlineForPdf' },
            {
              title: 'Responsible for Execution',
              dataKey: 'ResponsiblePerson'
            },
            { title: 'Importance', dataKey: 'Importance.value' },
            { title: 'Description', dataKey: 'Description' },
            { title: 'Modules', dataKey: 'Modules' },
            { title: 'DisplayCost', dataKey: 'Cost' },
            { title: 'DisplayCost', dataKey: 'DisplayCost' },
            { title: 'Event Location', dataKey: 'EventLocation' },
            { title: 'Business', dataKey: 'BusinessName' },
            { title: 'Done On', dataKey: 'CompletedDateForPdf' },
            { title: 'Created On', dataKey: 'CreatedOn' },
            { title: 'Created By', dataKey: 'CreatorName' }
          ]
        };
      })
    );

    // Set up navigation detection
    this.setupNavigationDetection();
  }

  /**
   * Set up navigation detection to clear filters when leaving the followup module
   */
  private setupNavigationDetection(): void {
    this.subscriptions.push(
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          const currentUrl = event.urlAfterRedirects;

          // Check if navigating outside the follow-up module
          if (!currentUrl.includes('/follow-up')) {
            // Clear filter state when leaving the module
            this.filterStateService.clearFilterState(this.FILTER_MODULE_KEY);
          }
        }
      })
    );
  }

  /**
   * Save current filter state to sessionStorage
   */
  private saveFilterStateToStorage(): void {
    if (this.isRestoringFilters) {
      return; // Don't save while restoring to avoid overwriting
    }

    try {
      const filterState = {
        // Filter DTO properties
        deviationFilterDto: this.deviationFilterDto,

        // Text filters
        noFilter: this.noFilter,
        businessNameFilter: this.businessNameFilter,
        titleFilter: this.titleFilter,
        checklistNameFilter: this.checklistNameFilter,
        activityNameFilter: this.activityNameFilter,
        departmentFilter: this.departmentFilter,

        // Autocomplete filters
        selectedFollowUpPerson: this.selectedFollowUpPerson,
        selectedExecutionPerson: this.selectedExecutionPerson,

        // Date filters
        startDate: this.startDate,
        endDate: this.endDate,
        craetedFromFilter: this.craetedFromFilter,
        createdToFilter: this.createdToFilter,

        // Dropdown filters
        currentDeviation: this.currentDeviation,
        createdByFilter: this.createdByFilter,
        clientFilter: this.clientFilter,

        // Selected filters tracking
        selectedFilters: this.selectedFilters
      };

      this.filterStateService.saveFilterState(
        this.FILTER_MODULE_KEY,
        filterState
      );

      // Save pagination state
      this.filterStateService.savePaginationState(this.FILTER_MODULE_KEY, {
        pageNumber: this.paginationRequest.pageNumber,
        pageSize: this.paginationRequest.pageSize
      });

      // Save sorting state
      this.filterStateService.saveSortingState(this.FILTER_MODULE_KEY, {
        sortColumn: this.paginationRequest.sortColumn,
        sortDirection: this.paginationRequest.sortDirection
      });
    } catch (error) {
      console.error('Error saving filter state:', error);
    }
  }

  /**
   * Restore filter state from sessionStorage
   */
  private restoreFilterStateFromStorage(): void {
    try {
      this.isRestoringFilters = true;

      const savedState = this.filterStateService.getFilterState<any>(
        this.FILTER_MODULE_KEY
      );

      if (savedState) {
        // Restore filter DTO
        if (savedState.deviationFilterDto) {
          this.deviationFilterDto = { ...savedState.deviationFilterDto };
        }

        // Restore text filters
        this.noFilter = savedState.noFilter || '';
        this.businessNameFilter = savedState.businessNameFilter || '';
        this.titleFilter = savedState.titleFilter || '';
        this.checklistNameFilter = savedState.checklistNameFilter || '';
        this.activityNameFilter = savedState.activityNameFilter || '';
        this.departmentFilter = savedState.departmentFilter || '';

        // Restore autocomplete filters
        this.selectedFollowUpPerson = savedState.selectedFollowUpPerson || null;
        this.selectedExecutionPerson =
          savedState.selectedExecutionPerson || null;

        // Restore date filters
        this.startDate = savedState.startDate;
        this.endDate = savedState.endDate;
        this.craetedFromFilter = savedState.craetedFromFilter || null;
        this.createdToFilter = savedState.createdToFilter || null;

        // Restore dropdown filters
        if (savedState.currentDeviation !== undefined) {
          this.currentDeviation = savedState.currentDeviation;
        }

        // Restore Created By filter - ensure both the filter value and DTO are in sync
        this.createdByFilter = savedState.createdByFilter || null;
        // If deviationFilterDto was restored and has createdBy, use that
        if (!this.createdByFilter && this.deviationFilterDto.createdBy) {
          this.createdByFilter = this.deviationFilterDto.createdBy;
        }

        this.clientFilter = savedState.clientFilter || null;

        // Restore selected filters
        if (savedState.selectedFilters) {
          this.selectedFilters = { ...savedState.selectedFilters };
        }
      }

      this.showCostColumn =
        sessionStorage.getItem('search_FollowupDev_ShowCost') === '1';

      // Restore pagination state
      const savedPagination = this.filterStateService.getPaginationState<any>(
        this.FILTER_MODULE_KEY
      );
      if (savedPagination) {
        this.paginationRequest.pageNumber = savedPagination.pageNumber || 1;
        this.paginationRequest.pageSize = savedPagination.pageSize || 10;
      }

      // Restore sorting state
      const savedSorting = this.filterStateService.getSortingState<any>(
        this.FILTER_MODULE_KEY
      );
      if (savedSorting) {
        this.paginationRequest.sortColumn = savedSorting.sortColumn;
        this.paginationRequest.sortDirection =
          savedSorting.sortDirection || 'ASC';
      }

      // Clear legacy filter states
      this.filterStateService.clearLegacyFilterStates([
        'search_FollowupDev_Dept',
        'search_FollowupDev_Client',
        'search_FollowupDev_CreatedTo',
        'search_FollowupDev_CreatedFrom',
        'search_FollowupDev_Topics',
        'search_FollowupDev_Desc',
        'search_FollowupDev_TypeOfCase',
        'search_FollowupDev_ResponsibleForFollowup',
        'search_FollowupDev_ResponsibleForExecution',
        'search_FollowupDev_CreatedBy'
      ]);

      this.isRestoringFilters = false;
    } catch (error) {
      console.error('Error restoring filter state:', error);
      this.isRestoringFilters = false;
    }
  }

  /**
   * After view initialization - populate filter inputs with restored values
   */
  ngAfterViewInit(): void {
    // Use setTimeout to ensure all view children and async data are loaded
    // Longer timeout to allow dropdown options to be populated from async calls
    // Try multiple times with increasing delays to ensure data is loaded
    setTimeout(() => {
      this.populateFilterInputs();
    }, 300);

    // Retry after 800ms to catch any late-loading dropdowns
    setTimeout(() => {
      this.populateFilterInputs();
    }, 800);
  }

  /**
   * Populate filter input fields with restored values from sessionStorage
   */
  private populateFilterInputs(): void {
    // Text filters with [(ngModel)] binding automatically populate:
    // - noFilter, businessNameFilter, titleFilter, checklistNameFilter, activityNameFilter, departmentFilter
    //
    // Note: Even dropdowns with [(ngModel)] need manual population to ensure proper display
    //
    // Populate all dropdowns:

    // Show Deviation dropdown
    if (this.showDeviationDropdown && this.currentDeviation !== undefined) {
      if (this.ShowDeviation && this.ShowDeviation.length > 0) {
        const showDevOption = this.ShowDeviation.find(
          (opt: any) => opt.value === this.currentDeviation.toString()
        );
        if (showDevOption) {
          this.showDeviationDropdown.value = this.currentDeviation.toString();
          this.showDeviationDropdown.selectedOption = showDevOption;
          this.showDeviationDropdown.cd.detectChanges();
        }
      }
    }

    // Case dropdown (uses form control)
    if (this.caseDropdown && this.deviationFilterDto.caseId) {
      if (this.Case && this.Case.length > 0) {
        const caseOption = this.Case.find(
          (c: any) => c.value === this.deviationFilterDto.caseId
        );
        if (caseOption) {
          this.caseDropdown.value = this.deviationFilterDto.caseId;
          this.caseDropdown.selectedOption = caseOption;
          if (this.deviationSearch) {
            this.deviationSearch.patchValue({
              typeOfCase: this.deviationFilterDto.caseId
            });
          }
          this.caseDropdown.cd.detectChanges();
        }
      }
    }

    // Topics dropdown (uses form control)
    if (this.topicDropdown && this.deviationFilterDto.topicId) {
      if (this.Topics && this.Topics.length > 0) {
        const topicOption = this.Topics.find(
          (t: any) => t.value === this.deviationFilterDto.topicId
        );
        if (topicOption) {
          this.topicDropdown.value = this.deviationFilterDto.topicId;
          this.topicDropdown.selectedOption = topicOption;
          if (this.deviationSearch) {
            this.deviationSearch.patchValue({
              topic: this.deviationFilterDto.topicId
            });
          }
          this.topicDropdown.cd.detectChanges();
        }
      }
    }

    // Sub-department dropdown
    if (this.subDepControl && this.deviationFilterDto.subDepartmentId) {
      if (this.subDepartments && this.subDepartments.length > 0) {
        const subDeptOption = this.subDepartments.find(
          (sd: any) => sd.value === this.deviationFilterDto.subDepartmentId
        );
        if (subDeptOption) {
          this.subDepControl.value = this.deviationFilterDto.subDepartmentId;
          this.subDepControl.selectedOption = subDeptOption;
          this.subDepControl.cd.detectChanges();
        }
      }
    }

    // Importance dropdown
    if (this.impControl && this.deviationFilterDto.importance) {
      if (this.importances && this.importances.length > 0) {
        const importanceOption = this.importances.find(
          (imp: any) => imp.value === this.deviationFilterDto.importance
        );
        if (importanceOption) {
          this.impControl.value = this.deviationFilterDto.importance;
          this.impControl.selectedOption = importanceOption;
          this.impControl.cd.detectChanges();
        }
      }
    }

    // Department dropdown (for business users)
    if (this.depControl && this.deviationFilterDto.department) {
      if (this.departments && this.departments.length > 0) {
        const dept = this.departments.find(
          (d: any) => d.label === this.deviationFilterDto.department
        );
        if (dept) {
          this.depControl.value = dept.value;
          this.depControl.selectedOption = dept;
          this.depControl.cd.detectChanges();
        }
      }
    }

    // Modules dropdown
    if (this.modulesDropdown && this.deviationFilterDto.modules) {
      if (this.vModules && this.vModules.length > 0) {
        const moduleOption = this.vModules.find(
          (m: any) => m.value === this.deviationFilterDto.modules
        );
        if (moduleOption) {
          this.modulesDropdown.value = this.deviationFilterDto.modules;
          this.modulesDropdown.selectedOption = moduleOption;
          this.modulesDropdown.cd.detectChanges();
        }
      }
    }

    // Status dropdown
    if (this.statusDropdown && this.deviationFilterDto.status) {
      if (this.statuses && this.statuses.length > 0) {
        const statusOption = this.statuses.find(
          (s: any) => s.value === this.deviationFilterDto.status
        );
        if (statusOption) {
          this.statusDropdown.value = this.deviationFilterDto.status;
          this.statusDropdown.selectedOption = statusOption;
          this.statusDropdown.cd.detectChanges();
        }
      }
    }

    // Created By dropdown (has [(ngModel)] but needs manual population)
    const createdByValue =
      this.createdByFilter || this.deviationFilterDto.createdBy;
    if (this.createdByDropdown && createdByValue) {
      if (this.createdBy && this.createdBy.length > 0) {
        this.createdByDropdown.value = createdByValue;
        this.createdByFilter = createdByValue;
        this.createdByDropdown.cd.detectChanges();
      }
    }

    // Client dropdown (has [(ngModel)] but needs manual population)
    if (this.clientDropdown && this.clientFilter) {
      if (this.Client && this.Client.length > 0) {
        this.clientDropdown.value = this.clientFilter;
        this.clientDropdown.cd.detectChanges();
      }
    }

    // Autocomplete fields with [(ngModel)] will automatically populate
  }

  //#endregion

  //#region page-events
  /**
   * bind list with status icon
   */
  ngOnInit(): void {
    document.querySelector('body').classList.remove('opened');

    // Restore filter state from sessionStorage before initializing
    this.restoreFilterStateFromStorage();

    this.currentDeviation = this.currentDeviation || 1; // Use restored value if available
    this.userRole = BaseServices.UserRole;
    this.newButtonDisplay =
      BaseServices.roleId === '1'
        ? false
        : BaseServices.roleId === '2'
          ? true // Portal users can see NEW button
          : true;
    this.isShowNewButton =
      BaseServices.roleId === '1'
        ? false
        : BaseServices.roleId === '2'
          ? true // Portal users can see NEW button
          : true;
    this.isAdmin = BaseServices.roleId === '1' ? true : false;
    this.isPortal = BaseServices.roleId === '2' ? true : false;
    this.isEditor = BaseServices.roleId === '3' ? true : false;

    this.onAdministrateDeviation();

    if (window.name === 'Remote') {
      this.subscriptions.push(
        this.deviationService.getRModeFeature().subscribe((feature: any) => {
          if (feature) {
            this.businessFeature = <SessionFeature[]>(
              JSON.parse(feature.Features)
            );
            var internal = this.businessFeature.filter(
              x => x.name === 'Internalcontrol' && x.checked === true
            );
            var project = this.businessFeature.filter(
              x => x.name === 'Project' && x.checked === true
            );
            var othersystem = this.businessFeature.filter(
              x => x.name === 'OtherSystems' && x.checked === true
            );
            var qualitysystem = this.businessFeature.filter(
              x => x.name === 'QualitySystem' && x.checked === true
            );
            var fdv = this.businessFeature.filter(
              x => x.name === 'FDV' && x.checked === true
            );
            var Vehicles = this.businessFeature.filter(
              x => x.name === 'Vehicles' && x.checked === true
            );
            var FoodSafety = this.businessFeature.filter(
              x => x.name === 'FoodSafety' && x.checked === true
            );
            var KubaControl = this.businessFeature.filter(
              x => x.name === 'KubaControl' && x.checked === true
            );
            var Kunde = this.businessFeature.filter(
              x => x.name === 'Kunde EL' && x.checked === true
            );
            if (internal.length > 0) {
              this.isInternalControl = true;
              this.activatedFeatureIds.push(FeatureKey.INTERNAL_CONTROL);
            }
            if (project.length > 0) {
              this.isproject = true;
              this.activatedFeatureIds.push(FeatureKey.PROJECT);
            }
            if (othersystem.length > 0) {
              this.isothersystem = true;
              this.activatedFeatureIds.push(FeatureKey.OTHER_SYSTEMS);
            }
            if (qualitysystem.length > 0) {
              this.isqualitysystem = true;
              this.activatedFeatureIds.push(FeatureKey.QUALITY_SYSTEMS);
            }
            if (fdv.length > 0) {
              this.isfdv = true;
              this.activatedFeatureIds.push(FeatureKey.FDV);
            }
            if (Vehicles.length > 0) {
              this.isVehicles = true;
              this.activatedFeatureIds.push(FeatureKey.VEHICLES);
            }
            if (FoodSafety.length > 0) {
              this.isFoodSafety = true;
              this.activatedFeatureIds.push(FeatureKey.FOOD_SAFETY);
            }
            if (KubaControl.length > 0) {
              this.isKubaControl = true;
              this.activatedFeatureIds.push(FeatureKey.KUBA_CONTROL);
            }
            if (Kunde.length > 0) {
              this.isKunde = true;
            }
            this.clearClientFilterWithoutKundeEl();

            const followUpModule = this.businessFeature.find(
              x => x.id === FeatureKey.FOLLOW_UP
            );
            if (followUpModule && followUpModule.children) {
              const qrCodeFeature = followUpModule.children.find(
                x =>
                  x.id === FeatureKey.DEVIATION_QR_GENERATOR &&
                  x.checked === true
              );
              if (qrCodeFeature) {
                this.isQrCode = true;
              }
            }
          }
        })
      );
    } else {
      let featuresBaseDetails = FeaturesBaseServices.getFeatureDetails(
        BaseServices.getUserFeatures()
      );
      var internal = featuresBaseDetails.filter(
        x => x.name === 'Internalcontrol' && x.checked === true
      );
      var project = featuresBaseDetails.filter(
        x => x.name === 'Project' && x.checked === true
      );
      var othersystem = featuresBaseDetails.filter(
        x => x.name === 'OtherSystems' && x.checked === true
      );
      var qualitysystem = featuresBaseDetails.filter(
        x => x.name === 'QualitySystem' && x.checked === true
      );
      var fdv = featuresBaseDetails.filter(
        x => x.name === 'FDV' && x.checked === true
      );
      var Vehicles = featuresBaseDetails.filter(
        x => x.name === 'Vehicles' && x.checked === true
      );
      var FoodSafety = featuresBaseDetails.filter(
        x => x.name === 'FoodSafety' && x.checked === true
      );
      var KubaControl = featuresBaseDetails.filter(
        x => x.name === 'KubaControl' && x.checked === true
      );
      var Kunde = featuresBaseDetails.filter(
        x => x.name === 'Kunde EL' && x.checked === true
      );
      if (internal.length > 0) {
        this.isInternalControl = true;
        this.activatedFeatureIds.push(FeatureKey.INTERNAL_CONTROL);
      }
      if (project.length > 0) {
        this.isproject = true;
        this.activatedFeatureIds.push(FeatureKey.PROJECT);
      }
      if (othersystem.length > 0) {
        this.isothersystem = true;
        this.activatedFeatureIds.push(FeatureKey.OTHER_SYSTEMS);
      }
      if (qualitysystem.length > 0) {
        this.isqualitysystem = true;
        this.activatedFeatureIds.push(FeatureKey.QUALITY_SYSTEMS);
      }
      if (fdv.length > 0) {
        this.isfdv = true;
        this.activatedFeatureIds.push(FeatureKey.FDV);
      }
      if (Vehicles.length > 0) {
        this.isVehicles = true;
        this.activatedFeatureIds.push(FeatureKey.VEHICLES);
      }
      if (FoodSafety.length > 0) {
        this.isFoodSafety = true;
        this.activatedFeatureIds.push(FeatureKey.FOOD_SAFETY);
      }
      if (KubaControl.length > 0) {
        this.isKubaControl = true;
        this.activatedFeatureIds.push(FeatureKey.KUBA_CONTROL);
      }
      if (Kunde.length > 0) {
        this.isKunde = true;
      }
      this.clearClientFilterWithoutKundeEl();

      const followUpModuleFeature = featuresBaseDetails.find(
        x => x.id === FeatureKey.FOLLOW_UP && x.checked === true
      );
      if (followUpModuleFeature && followUpModuleFeature.children) {
        const qrCodeFeature = followUpModuleFeature.children.find(
          x => x.id === FeatureKey.DEVIATION_QR_GENERATOR && x.checked === true
        );
        if (qrCodeFeature) {
          this.isQrCode = true;
        }
      }
    }

    // To hide side menu bar
    document.querySelector('body').classList.remove('opened');
    this.bindDepartmentDropdown();
    this.subscriptions.push(
      this.translate.stream('RISKFIGURE_DROPDOWN').subscribe(val => {
        this.importances = [];
        this.importances.push(
          { label: val.SELECT, value: null },
          { label: val.LOW, value: 'Low' },
          { label: val.MEDIUM, value: 'Medium' },
          { label: val.HIGH, value: 'High' }
        );
      })
    );
    if (BaseServices.UserRole === 'Admin') {
      this.isShowPlusbutton = false;
    }
    if (+BaseServices.roleId === 2) {
      this.isShowPlusbutton = false;
    }
    let currentUserRole = BaseServices.UserRole;
    let userRightsId = Rights.ADMINISTRATE_DEVIATION;
    if (+BaseServices.roleId === 5) {
      this.isShowPlusbutton = BaseServices.checkUserRights(
        userRightsId,
        currentUserRole
      );
    }

    this.vresperson = [];
    let responsiblePerson: any[];
    if (this.isAdmin == true) {
      responsiblePerson = this.route.snapshot.data['deviationuser'];
    } else {
      responsiblePerson = this.route.snapshot.data['user'];
    }

    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.vresperson = [];
        this.vresperson.push({ label: val.SELECT, value: null });
        if (responsiblePerson) {
          responsiblePerson.forEach((responblePerson: any) => {
            this.vresperson.push({
              label: responblePerson.Name,
              value: responblePerson.Id
            });
          });
        }
      })
    );

    if (BaseServices.roleId === '3') {
      this.isBusinessId = true;
      this.bindCreatedByDropDown(BaseServices.BusinessId);
    }

    this.vDepartment = [];
    let departments: any[];
    departments = this.route.snapshot.data['departments'];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.vDepartment = [];
        this.vDepartment.push({ label: val.SELECT, value: null });
      })
    );
    if (departments) {
      departments.forEach((department: any) => {
        this.vDepartment.push({
          label: department.Name,
          value: department.Id
        });
      });
    }
    this.subscriptions.push(
      this.translate.stream('RISKFIGURE_DROPDOWN').subscribe(val => {
        this.importances = [];
        this.importances.push(
          { label: val.SELECT, value: null },
          { label: val.LOW, value: 'Low' },
          { label: val.MEDIUM, value: 'Medium' },
          { label: val.HIGH, value: 'High' }
        );
      })
    );
    if (this.isPortal || (this.isAdmin && BaseServices.ApplicationId != 4)) {
      this.subscriptions.push(
        this.translate.stream('VMODULES').subscribe(val => {
          this.vModules = [];
          this.vModules.push(
            { label: val.SELECT, value: null },
            { label: val.KUBA_Control, value: 'KUBA_Control' },
            { label: val.FDV, value: 'FDV' },
            { label: val.FOLLOW_UP, value: 'Follow up' },
            { label: val.FOOD_SAFETY, value: 'FOOD_SAFETY' },
            { label: this.translate.instant('FLEXI_SAFETY_ROUNDS.MODULE'), value: 'FLEXI_SAFETY_ROUNDS.MODULE' },
            { label: val.INTERNAL_CONTROL, value: 'INTERNAL_CONTROL' },
            { label: val.OTHER_SYSTEMS, value: 'OTHER_SYSTEMS' },
            { label: val.PROJECT, value: 'PROJECT' },
            { label: val.QUALITY_SYSTEMS, value: 'QUALITY_SYSTEMS' },
            { label: val.Vehicle, value: 'Vehicle' }
          );
        })
      );
    } else {
      if (BaseServices.ApplicationId != 4) {
        this.isIKdeviation = true;
        this.subscriptions.push(
          this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
            this.vModules = [];
            this.vModules.push({ label: val.SELECT, value: null });

            // If in R mode, use the features from appSettings
            if (sessionStorage.getItem('RModeBusiness')) {
              const businessId: number | null = sessionStorage.getItem(
                'RModeBusinessId'
              )
                ? Number(sessionStorage.getItem('RModeBusinessId'))
                : null;

              if (businessId !== null) {
                this.deviationService
                  .getFeatureByBusiness(businessId)
                  .subscribe((deviationlist: string) => {
                    if (deviationlist) {
                      this.features = JSON.parse(
                        deviationlist
                      ) as SessionFeature[];
                      this.assignModulesWithApiData();
                    }
                  });
              }
            } else {
              this.features = BaseServices.userFeatures;
              this.assignModulesWithApiData();
            }
          })
        );
      } else if (BaseServices.ApplicationId == 4) {
        this.isAHdeviation = true;
        this.subscriptions.push(
          this.translate.stream('VMODULES').subscribe(val => {
            this.vModules = [];
            this.vModules.push(
              { label: val.SELECT, value: null },
              { label: 'EL', value: 'EL (' },
              { label: 'FA', value: 'FA (' },
              { label: 'FDV', value: 'FDV' },
              { label: 'Follow up', value: 'Follow up' },
              { label: 'IK', value: 'IK (' },
              { label: 'PR', value: 'PR (' },
              { label: 'SA', value: 'SA (' },
              { label: 'KJ', value: 'KJ (' }
            );
          })
        );
      } else {
        this.subscriptions.push(
          this.translate.stream('VMODULES').subscribe(val => {
            this.vModules = [];
            this.vModules.push(
              { label: val.SELECT, value: null },
              { label: val.KUNDE_EL, value: 'KUNDE_EL' },
              { label: val.FRAMEWORK_AGREEMENT, value: 'FRAMEWORK_AGREEMENT' },
              { label: val.FDV, value: 'FDV' },
              { label: val.FOLLOW_UP, value: 'Follow up' },
              { label: val.INTERNAL_CONTROL, value: 'INTERNAL_CONTROL' },
              { label: val.PROJECT, value: 'PROJECT' },
              { label: val.SERVICE_AGREEMENT, value: 'SERVICE_AGREEMENT' },
              { label: val.Vehicle, value: 'Vehicle' }
            );
          })
        );
      }
    }
    this.startChartCycling();
  }

  //#region selection methods

  /**
   * Handle individual deviation selection change
   * @param event Selection event from PrimeNG checkbox
   */
  onDeviationSelectionChange(event: any) {
    if (event.checked) {
      // Add to global selection
      this.allSelectedDeviations.add(event.data.Id);
    } else {
      // Remove from global selection
      this.allSelectedDeviations.delete(event.data.Id);
    }

    // Update the selectedDeviations array for current page
    this.selectedDeviations = this.deviationList.filter(
      (deviation: DeviationListDto) =>
        this.allSelectedDeviations.has(deviation.Id)
    );

    this.updateSelectAllState();
  }

  /**
   * Handle select all checkbox change (select all on current page)
   * @param event Selection event from PrimeNG checkbox
   */
  onSelectAllChange(event: any) {
    this.isAllSelected = event.checked;

    if (event.checked) {
      // Select all deviations on current page that are not "Done" (StatusId !== 9)
      this.deviationList.forEach((deviation: DeviationListDto) => {
        if (deviation.StatusId !== 9) {
          this.allSelectedDeviations.add(deviation.Id);
        }
      });
    } else {
      // Deselect all deviations on current page
      this.deviationList.forEach((deviation: DeviationListDto) => {
        this.allSelectedDeviations.delete(deviation.Id);
      });
    }

    // Update the selectedDeviations array
    this.selectedDeviations = this.deviationList.filter(
      (deviation: DeviationListDto) =>
        this.allSelectedDeviations.has(deviation.Id)
    );

    this.updateSelectAllState();
  }

  /**
   * Check if deviation is selected
   * @param deviation - Deviation to check
   * @returns true if deviation is selected
   */
  isDeviationSelected(deviation: DeviationListDto): boolean {
    return this.allSelectedDeviations.has(deviation.Id);
  }

  /**
   * Check if all deviations on current page are selected
   */
  isAllSelectedOnCurrentPage(): boolean {
    if (this.deviationList.length === 0) return false;
    const selectableDeviations = this.deviationList.filter(
      deviation => deviation.StatusId !== 9
    );
    if (selectableDeviations.length === 0) return false;
    return selectableDeviations.every((deviation: DeviationListDto) =>
      this.allSelectedDeviations.has(deviation.Id)
    );
  }

  /**
   * Update select all checkbox state based on current selection
   */
  updateSelectAllState() {
    this.isAllSelected = this.isAllSelectedOnCurrentPage();
  }

  /**
   * Clear all selected deviations
   */
  clearSelection() {
    this.allSelectedDeviations.clear();
    this.selectedDeviations = [];
    this.isAllSelected = false;
  }

  /**
   * Clear all selections (useful when filters change)
   */
  clearAllSelections() {
    this.allSelectedDeviations.clear();
    this.selectedDeviations = [];
    this.isAllSelected = false;
  }

  /**
   * Check if selected deviations can be deleted
   * @returns true if all selected deviations can be deleted
   */
  get canDeleteSelected(): boolean {
    return (
      this.allSelectedDeviations.size > 0 &&
      this.selectedDeviations.every(deviation => deviation.StatusId !== 9)
    );
  }

  //#endregion

  //#region sorting methods

  /**
   * Handle sort events from p-table
   * @param event Sort event from PrimeNG table
   */
  onSort(event: any): void {
    if (this.isLoadingData) return;

    const sortField = event.field;
    const sortOrder = event.order; // 1 for ASC, -1 for DESC

    // Map UI column name to stored procedure parameter name
    const mappedColumn = this.columnMapping[sortField];

    if (mappedColumn) {
      this.paginationRequest.sortColumn = mappedColumn;
      this.paginationRequest.sortDirection = sortOrder === 1 ? 'ASC' : 'DESC';

      this.validateSorting();

      this.paginationRequest.pageNumber = 1;

      this.bindDeviationList(false);
    }
  }

  /**
   * Validates and cleans the sorting parameters
   */
  private validateSorting(): void {
    const validSortColumns = [
      'No',
      'BusinessName',
      'Title',
      'CreatedOn',
      'DoneOn'
    ];

    if (
      this.paginationRequest.sortColumn &&
      !validSortColumns.includes(this.paginationRequest.sortColumn)
    ) {
      this.paginationRequest.sortColumn = undefined;
    }

    if (
      this.paginationRequest.sortDirection &&
      !['ASC', 'DESC'].includes(this.paginationRequest.sortDirection)
    ) {
      this.paginationRequest.sortDirection = 'ASC';
    }
  }

  /**
   * Clear sorting and reset to default
   */
  clearSorting(): void {
    if (this.paginationRequest) {
      this.paginationRequest.sortColumn = undefined;
      this.paginationRequest.sortDirection = 'ASC';
      this.paginationRequest.pageNumber = 1;

      // Reset table sorting UI
      if (this.deviationTable) {
        this.deviationTable.sortField = undefined;
        this.deviationTable.sortOrder = 1;
      }

      this.bindDeviationList(false);
    }
  }

  /**
   * Get current sort information for display
   */
  getCurrentSortInfo(): string {
    if (!this.paginationRequest.sortColumn) {
      return '';
    }

    return `${this.paginationRequest.sortColumn} (${this.paginationRequest.sortDirection})`;
  }

  /**
   * Get the count of active filters
   * @returns number of active filters
   */
  getActiveFiltersCount(): number {
    let count = 0;

    // Text filters
    if (this.noFilter) count++;
    if (this.businessNameFilter) count++;
    if (this.titleFilter) count++;
    if (this.checklistNameFilter) count++;
    if (this.activityNameFilter) count++;
    if (this.departmentFilter && (this.isAdmin || this.isPortal)) count++;

    // Dropdown filters from deviationFilterDto
    if (this.deviationFilterDto.status) count++;
    if (this.deviationFilterDto.importance) count++;
    if (this.deviationFilterDto.department && !this.isAdmin && !this.isPortal)
      count++;
    if (this.deviationFilterDto.modules) count++;
    if (this.deviationFilterDto.caseId) count++;
    if (this.deviationFilterDto.topicId) count++;
    if (this.deviationFilterDto.clientId) count++;
    if (this.deviationFilterDto.subDepartmentId) count++;
    if (this.deviationFilterDto.createdBy) count++;
    if (this.deviationFilterDto.followUpUserId) count++;
    if (this.deviationFilterDto.executionUserId) count++;
    if (this.deviationFilterDto.createdFrom) count++;
    if (this.deviationFilterDto.createdTo) count++;

    // Autocomplete filters
    if (this.selectedFollowUpPerson) count++;
    if (this.selectedExecutionPerson) count++;

    return count;
  }

  //#endregion

  /**
   * Fetches and assigns modules with API data, including sub-modules and features.
   * This method retrieves sub-modules from the API, processes them, and updates the `vModules` array
   * with translated labels and values. It also ensures that duplicate or excluded modules are not added.
   */
  assignModulesWithApiData() {
    // Admin and portal sessions have no business of their own (BusinessId 0),
    // which the sub-modules endpoint rejects with 400/403.
    if (!(BaseServices.BusinessId > 0)) {
      return;
    }

    this.subscriptions.push(
      this.deviationService
        .getModulesByDeviation(BaseServices.BusinessId)
        .subscribe(
          (apiSubModules: DeviationSubModule[]) => {
            this.createSubModuleLookup(apiSubModules);

            const excludedKeys = [
              'OUR_COMPANY',
              'DASHBOARD',
              'MY_PAGE',
              'EMPLOYEES',
              'CONTACTS',
              'CLIENT',
              'SUB_CONTRACTOR',
              'MANUALS',
              'SUPPLIERS',
              'INTERNAL_NEWS',
              'FLEXI',
              'ARCHIVE'
            ];

            const addedValues = new Set();

            this.features.forEach(feature => {
              if (
                feature.checked &&
                !excludedKeys.includes(feature.translationKey) &&
                !addedValues.has(feature.translationKey)
              ) {
                this.translate
                  .get(feature.translationKey)
                  .subscribe(translatedLabel => {
                    this.vModules.push({
                      label: translatedLabel,
                      value: feature.name
                    });
                    addedValues.add(feature.translationKey);
                  });
              }
            });

            const rounds = this.features.find(feature => feature.id === FeatureKey.FLEXI)
              ?.children?.find(feature => feature.id === FeatureKey.FLEXI_SAFETY_ROUNDS);
            if (rounds?.checked && !this.vModules.some(module => module.value === 'FLEXI_SAFETY_ROUNDS.MODULE')) {
              this.vModules.push({
                label: this.translate.instant('FLEXI_SAFETY_ROUNDS.MODULE'),
                value: 'FLEXI_SAFETY_ROUNDS.MODULE'
              });
            }

            if (apiSubModules && apiSubModules.length > 0) {
              const distinctSubModules = new Set<string>();

              apiSubModules.forEach((subModule: DeviationSubModule) => {
                distinctSubModules.add(subModule.DeviationSubModuleName);
              });

              distinctSubModules.forEach((subModuleName: string) => {
                const existingModule = this.vModules.find(
                  m => m.value === subModuleName || m.label === subModuleName
                );

                if (!existingModule && !addedValues.has(subModuleName)) {
                  this.vModules.push({
                    label: subModuleName,
                    value: subModuleName
                  });
                  addedValues.add(subModuleName);
                }
              });

              const selectOption = this.vModules.find(m => m.value === null);
              const otherModules = this.vModules.filter(m => m.value !== null);
              otherModules.sort((a, b) => a.label.localeCompare(b.label));

              this.vModules = selectOption
                ? [selectOption, ...otherModules]
                : otherModules;
            }
          },
          error => {
            this.assignModules();
          }
        )
    );
  }

  /**
   * Create a lookup map for efficient sub-module matching
   */
  private createSubModuleLookup(subModules: DeviationSubModule[]): void {
    this.subModuleLookup.clear();
    this.subModuleNames.clear();
    this.deviationSubModules = subModules;

    subModules.forEach(subModule => {
      this.subModuleLookup.set(
        subModule.DeviationId,
        subModule.DeviationSubModuleName
      );
      this.subModuleNames.add(subModule.DeviationSubModuleName);
    });
  }

  /**
   * Transform module names for query parameters
   * @param moduleName The module name to transform
   * @returns Transformed module name for query parameters
   */
  private transformModuleForQuery(moduleName: string | null): string | null {
    if (!moduleName) return null;

    const moduleTransformMap: { [key: string]: string } = {
      FoodSafety: 'FOOD_SAFETY',
      KubaControl: 'KUBA_Control',
      QualitySystem: 'QUALITY_SYSTEMS',
      OtherSystems: 'OTHER_SYSTEMS',
      Internalcontrol: 'INTERNAL_CONTROL'
    };

    return moduleTransformMap[moduleName] || moduleName;
  }

  /**
   * Apply sub-module mapping to deviation list
   */
  private applySubModuleMapping(deviations: DeviationListDto[]): void {
    if (!deviations || deviations.length === 0) {
      return;
    }

    deviations.forEach(deviation => {
      const subModuleName = this.subModuleLookup.get(deviation.Id);

      if (subModuleName) {
        deviation.Modules = subModuleName;
      }
    });
  }

  assignModules() {
    const excludedKeys = [
      'OUR_COMPANY',
      'DASHBOARD',
      'MY_PAGE',
      'EMPLOYEES',
      'CONTACTS',
      'CLIENT',
      'SUB_CONTRACTOR',
      'MANUALS',
      'SUPPLIERS',
      'INTERNAL_NEWS',
      'FLEXI',
      'ARCHIVE'
    ];
    const addedValues = new Set();
    this.features.forEach(feature => {
      if (
        feature.checked &&
        !excludedKeys.includes(feature.translationKey) &&
        !addedValues.has(feature.translationKey)
      ) {
        this.translate
          .get(feature.translationKey)
          .subscribe(translatedLabel => {
            this.vModules.push({
              label: translatedLabel,
              value: feature.name
            });
            addedValues.add(feature.translationKey);
          });
      }
    });
  }
  bindCreatedByDropDown(businessId: number) {
    this.createdBy = [];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.createdBy = [];
        this.createdBy.push({ label: val.SELECT, value: null });
        this.subscriptions.push(
          this.deviationService.getUser(businessId).subscribe((list: any) => {
            if (list) {
              list.forEach((element: any) => {
                this.createdBy.push({
                  label: element.Name,
                  value: element.ContactPersonId
                });
              });
            }
          })
        );
      })
    );
  }
  /**
   * bind the department dropdown list
   */
  bindDepartmentDropdown() {
    this.departments = [];
    let roleId = BaseServices.roleId;
    if (roleId === '1' || roleId === '2') {
      this.departmentList = this.route.snapshot.data['departmentPortal'];
    } else {
      this.departmentList = this.route.snapshot.data['department'];
    }
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.departments = [];
        this.departments.push({ label: val.SELECT, value: null });
        if (this.departmentList) {
          this.departmentList.forEach((department: any) => {
            this.departments.push({
              label: department.Name,
              value: department.Id
            });
            this.departmentIds.push(department.Id);
          });
        }
      })
    );
  }

  /**
   * bind the sub department dropdown list
   */
  bindSubDepartmentDropdown(value: number[]) {
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.subDepartments = [];
        this.subDepartments.push({ label: val.SELECT, value: null });
        this.employeeServices
          .getAllSubDepartments(value)
          .subscribe((subDepartment: any) => {
            subDepartment.forEach((element: any) => {
              if (subDepartment) {
                this.subDepartments.push({
                  label: element.Name,
                  value: element.Id
                });
              }
            });
          });
      })
    );
  }
  //#endregion

  /**
   * Filter follow up persons for autocomplete
   */
  filterFollowUpPersons(event: any) {
    const query = event.query;
    this.filteredFollowUpPersons = this.followup.filter(
      person =>
        person.label && person.label.toLowerCase().includes(query.toLowerCase())
    );
  }

  /**
   * Filter execution persons for autocomplete
   */
  filterExecutionPersons(event: any) {
    const query = event.query;
    this.filteredExecutionPersons = this.vresperson.filter(
      person =>
        person.label && person.label.toLowerCase().includes(query.toLowerCase())
    );
  }

  //#region page-destroy-event

  ngOnDestroy() {
    document.querySelector('body').classList.add('opened');

    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }

    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  //#endregion

  /**
   *  filter list based on Type of case
   * @param e  {any}
   * @param topicDropdown  {any}
   */
  onTopicChanged(topicDropdown: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = topicDropdown?.value;
    const selectedLabel = topicDropdown?.selectedOption?.label;

    sessionStorage.setItem(
      'search_FollowupDev_TypeOfCase',
      selectedLabel || ''
    );

    this.selectedFilters.topic =
      selectedLabel !== 'Select' ? selectedLabel : null;
    this.deviationFilterDto.topicId =
      selectedValue && selectedValue !== 'Select' ? selectedValue : undefined;

    this.paginationRequest.pageNumber = 1;

    this.bindDeviationList(false);
  }

  /**
   *  filter list based on Type of case
   * @param e  {any}
   * @param caseDropdown  {any}
   */
  onCaseChanged(caseDropdown: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = caseDropdown?.value;
    const selectedLabel = caseDropdown?.selectedOption?.label;

    sessionStorage.setItem(
      'search_FollowupDev_TypeOfCase',
      selectedLabel || ''
    );

    this.selectedFilters.case =
      selectedLabel !== 'Select' ? selectedLabel : null;

    this.deviationFilterDto.caseId =
      selectedValue && selectedValue !== 'Select' ? selectedValue : undefined;

    this.paginationRequest.pageNumber = 1;
    this.bindDeviationList(false);
  }

  /**
   * custom filter datatable of status
   */
  onStatusChanged(event: any, statusDropdown?: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = event?.value !== undefined ? event.value : event;

    if (!this.isAdmin && !this.isPortal) {
      this.refreshSubModulesAndDropdown();
    }

    this.deviationFilterDto.status = selectedValue || undefined;
    this.paginationRequest.pageNumber = 1;

    this.bindDeviationList(false);
  }

  onModuleChange(e: DropdownEvent) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = e.value;
    const transformedValue = this.transformModuleForQuery(selectedValue);

    if (transformedValue && this.subModuleNames.has(transformedValue)) {
      this.deviationFilterDto.modules = transformedValue;
    } else {
      this.deviationFilterDto.modules = transformedValue || undefined;
    }

    this.paginationRequest.pageNumber = 1;
    this.bindDeviationList(false);
  }

  refreshSubModulesAndDropdown(): void {
    if (this.isAdmin || this.isPortal) {
      return;
    }

    this.subscriptions.push(
      this.deviationService
        .getModulesByDeviation(BaseServices.BusinessId)
        .subscribe(
          (subModules: DeviationSubModule[]) => {
            this.createSubModuleLookup(subModules);

            if (this.deviationList && this.deviationList.length > 0) {
              this.applySubModuleMapping(this.deviationList);
            }
          },
          error => {}
        )
    );
  }

  /**
   * Handle follow up person selection from autocomplete
   */
  onFollowupSelected(selectedPerson: SelectItem<number> | null) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = selectedPerson?.value ?? null;

    sessionStorage.setItem(
      'search_FollowupDev_ResponsibleForFollowup',
      selectedValue?.toString() ?? ''
    );

    this.selectedFilters.followUp = selectedValue?.toString() ?? null;
    this.deviationFilterDto.followUpUserId = selectedValue || undefined;
    this.paginationRequest.pageNumber = 1;
    this.bindDeviationList();
  }

  /**
   * Handle execution person selection from autocomplete
   */
  onExecutionSelected(selectedPerson: SelectItem<number> | null) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = selectedPerson?.value ?? null;

    sessionStorage.setItem(
      'search_FollowupDev_ResponsibleForExecution',
      selectedValue?.toString() ?? ''
    );

    this.selectedFilters.execution = selectedValue?.toString() ?? null;
    this.deviationFilterDto.executionUserId = selectedValue || undefined;
    this.paginationRequest.pageNumber = 1;
    this.bindDeviationList();
  }

  onImportanceChange(e: any, importanceControl: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = e.value;

    this.deviationFilterDto.importance = selectedValue || undefined;

    this.paginationRequest.pageNumber = 1;

    this.bindDeviationList(false);
  }

  /** Drops a restored client filter when the business has no Kunde EL module. */
  private clearClientFilterWithoutKundeEl(): void {
    if (this.isKunde) {
      return;
    }

    this.clientFilter = null;
    this.deviationFilterDto.clientId = undefined;
    sessionStorage.removeItem('search_FollowupDev_Client');
  }

  /**
   *  filter list based on Client
   * @param e {any}
   * @param clientDropdown {any}
   */
  onClientChanged(clientDropdown: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = clientDropdown?.value;

    sessionStorage.setItem('search_FollowupDev_Client', selectedValue || '');

    this.deviationFilterDto.clientId = selectedValue || undefined;

    this.paginationRequest.pageNumber = 1;

    this.bindDeviationList(false);
  }
  /**
   * filter deviation list based on show devaition value
   * @param e {any}
   * @param showDeviationDropdown {any}
   */
  onShowDeviationChanged(e: any) {
    const selectedValue = e.value;
    let currentUserRole = BaseServices.UserRole;
    let userRightsId = Rights.SEE_ONLY_DEVIATION_IN_OWN_DEPT;
    this.isShowDeptDeviation = BaseServices.checkUserRights(
      userRightsId,
      currentUserRole
    );

    if (selectedValue === '1') {
      this.currentDeviation = 1;

      this.deviationFilterDto = {};

      this.paginationRequest.pageNumber = 1;

      this.bindDeviationList();
    } else if (selectedValue === '2') {
      this.currentDeviation = 2;

      this.deviationFilterDto = {
        myOwnDeviation: true,
        userId: BaseServices.UserId
      };

      this.paginationRequest.pageNumber = 1;

      this.bindDeviationList();
    }
  }
  /**
   * save and updating topic
   */
  saveTopic() {
    this.loading = true;
    let reskTopic = new Topic();
    reskTopic.Id = this.topicId ? this.topicId : 0;
    reskTopic.Name = this.topicForm.value.Topic;
    reskTopic.Status = '1';
    reskTopic.BusinessId = BaseServices.BusinessId;
    if (reskTopic.Id > 0) {
      this.subscriptions.push(
        this.deviationService
          .updateTopics(reskTopic)
          .subscribe(isTopicUpdated => {
            if (isTopicUpdated) {
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.loading = false;
              this.bindTopicDropdown();
              this.deviationSearch.get('topic')!.patchValue(isTopicUpdated.Id);
            } else {
              this.existsTopicAlerttext = this.translate.instant(`TOPIC_EXIST`);
              this.isTopicNameExists = true;
              this.loading = false;
              setTimeout(() => {
                this.isTopicNameExists = false;
              }, 3000);
            }
          })
      );
    } else {
      this.subscriptions.push(
        this.deviationService.addTopics(reskTopic).subscribe(isTopicAdded => {
          if (isTopicAdded) {
            this.notifications.success('UI_NOTIFICATIONS.SAVED');
            this.loading = false;
            this.bindTopicDropdown();
            this.riskanalysisService.clearCachedTopic();
            this.deviationSearch.get('topic')!.patchValue(isTopicAdded.Id);
          } else {
            this.existsTopicAlerttext = this.translate.instant(`TOPIC_EXIST`);
            this.isTopicNameExists = true;
            this.loading = false;
            setTimeout(() => {
              this.isTopicNameExists = false;
            }, 3000);
          }
        })
      );
    }
    this.clear();
  }
  clear() {
    this.topicId = 0;
    this.topicForm = this._fb.group({
      Topic: ''
    });
  }
  /**
   * save type of case
   */
  saveTypeOfCase() {
    this.loading = true;
    let typeOfcase = new TypeOfCase();
    typeOfcase.Id = this.caseId ? this.caseId : 0;
    typeOfcase.Name = this.caseForm.value.Case;
    typeOfcase.Status = '1';
    typeOfcase.BusinessId = BaseServices.BusinessId;
    typeOfcase.ApplicationId = BaseServices.ApplicationId;
    if (typeOfcase.Id > 0) {
      typeOfcase.ModifiedBy = BaseServices.UserId;
      this.subscriptions.push(
        this.deviationService
          .updateCaseType(typeOfcase.Id, typeOfcase)
          .subscribe(isCaseUpdated => {
            if (isCaseUpdated) {
              this.addtypeOfCase = false;
              this.bindTypeofCaseDropdown();
              this.deviationSearch
                .get('typeOfCase')!
                .patchValue(isCaseUpdated.Id);
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.loading = false;
            } else {
              this.existsTypeCaseAlerttext =
                this.translate.instant(`TOPIC_EXIST`);
              this.isTypeCaseNameExists = true;
              this.loading = false;
              setTimeout(() => {
                this.isTypeCaseNameExists = false;
              }, 3000);
            }
          })
      );
    } else {
      typeOfcase.CreatedBy = BaseServices.UserId;
      this.subscriptions.push(
        this.deviationService.addTypeCase(typeOfcase).subscribe(isCaseAdded => {
          if (isCaseAdded) {
            this.addtypeOfCase = false;
            this.deviationService.clearCachedCaseType();
            this.deviationSearch.get('typeOfCase')!.patchValue(isCaseAdded.Id);
            this.bindTypeofCaseDropdown();
            this.notifications.success('UI_NOTIFICATIONS.SAVED');
            this.loading = false;
          } else {
            this.existsTypeCaseAlerttext =
              this.translate.instant(`TOPIC_EXIST`);
            this.isTypeCaseNameExists = true;
            this.loading = false;
            setTimeout(() => {
              this.isTypeCaseNameExists = false;
            }, 3000);
          }
        })
      );
    }
    this.clearCaseForm();
  }
  clearCaseForm() {
    this.caseId = 0;
    this.caseForm = this._fb.group({
      Case: ''
    });
  }
  /**
   * startdate calendar onselect event
   * @param event {any}
   */
  onStartDateChanged(event: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    if (event instanceof Date) {
      const date = new Date(event);
      date.setHours(0, 0, 0, 0);
      this.deviationFilterDto.createdFrom = date.toISOString();
      sessionStorage.setItem(
        'search_FollowupDev_CreatedFrom',
        date.toISOString()
      );
    } else {
      this.deviationFilterDto.createdFrom = undefined;
      sessionStorage.removeItem('search_FollowupDev_CreatedFrom');
    }

    this.paginationRequest.pageNumber = 1;
    this.bindDeviationList(false);
  }

  /**
   * enddate calendar onselect event
   * @param event {any}
   */
  onEndDateChanged(event: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    if (event instanceof Date) {
      const date = new Date(event);
      date.setHours(23, 59, 59, 999);
      this.deviationFilterDto.createdTo = date.toISOString();
      sessionStorage.setItem(
        'search_FollowupDev_CreatedTo',
        date.toISOString()
      );
    } else {
      this.deviationFilterDto.createdTo = undefined;
      sessionStorage.removeItem('search_FollowupDev_CreatedTo');
    }

    this.paginationRequest.pageNumber = 1;
    this.bindDeviationList(false);
  }

  /**
   * edit topic
   * @param Topictype {any}
   */
  editTopicType(topic: Topic) {
    this.topicId = topic.Id!;
    let result = {
      Topic: topic.Name
    };
    (<FormGroup>this.topicForm).setValue(result, { onlySelf: true });
  }
  /**
   * delete topic
   * @param id {any}
   */
  deleteTopic(id: any) {
    this.confirmationService.confirm({
      message: this.translate.instant('DELETE_THIS_RECORD'),
      accept: () => {
        this.subscriptions.push(
          this.deviationService.deleteTopics(id).subscribe(isTopicDeleted => {
            if (isTopicDeleted) {
              this.notifications.success('UI_NOTIFICATIONS.DELETED');
              this.riskanalysisService.clearCachedTopic();
              this.bindTopicDropdown();
            }
          })
        );
      }
    });
  }
  /**
   * edit type of case
   * @param TypeOfCase {any}
   */
  editTypeOfCase(typeOfCase: TypeOfCase) {
    this.caseId = typeOfCase.Id!;
    let result = {
      Case: typeOfCase.Name
    };
    (<FormGroup>this.caseForm).setValue(result, { onlySelf: true });
  }
  /**
   * delete type of case
   * @param deleteType {any}
   */
  deleteTypeOfCase(deleteType: any) {
    this.confirmationService.confirm({
      message: this.translate.instant('DELETE_THIS_RECORD'),
      accept: () => {
        this.subscriptions.push(
          this.deviationService
            .deleteTypeCase(deleteType)
            .subscribe(isCaseDeleted => {
              if (isCaseDeleted) {
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
                this.deviationService.clearCachedCaseType();
                this.bindTypeofCaseDropdown();
              }
            })
        );
      }
    });
  }

  /**
   * Handle follow up autocomplete clear
   */
  onFollowupCleared() {
    this.selectedFollowUpPerson = null;
    this.onFollowupSelected(null);
  }

  /**
   * Handle execution autocomplete clear
   */
  onExecutionCleared() {
    this.selectedExecutionPerson = null;
    this.onExecutionSelected(null);
  }

  onStatusCleared() {
    this.onStatusChanged(null);
  }

  /**
   * fetches data and refreshes grid
   */
  clearFilters() {
    if (this.isLoadingData) return;

    // Clear persisted filter state
    this.filterStateService.clearFilterState(this.FILTER_MODULE_KEY);

    // Clear legacy sessionStorage items (for backward compatibility)
    sessionStorage.removeItem('search_FollowupDev_Dept');
    sessionStorage.removeItem('search_FollowupDev_Client');
    sessionStorage.removeItem('search_FollowupDev_CreatedTo');
    sessionStorage.removeItem('search_FollowupDev_CreatedFrom');
    sessionStorage.removeItem('search_FollowupDev_Topics');
    sessionStorage.removeItem('search_FollowupDev_Desc');
    sessionStorage.removeItem('search_FollowupDev_TypeOfCase');
    sessionStorage.removeItem('search_FollowupDev_ResponsibleForFollowup');
    sessionStorage.removeItem('search_FollowupDev_ResponsibleForExecution');
    sessionStorage.removeItem('search_FollowupDev_CreatedBy');
    sessionStorage.removeItem('search_FollowupDev_Status');
    sessionStorage.removeItem('search_FollowupDev_ShowCost');
    this.showCostColumn = false;

    // Clear text filters
    this.noFilter = '';
    this.businessNameFilter = '';
    this.titleFilter = '';
    this.checklistNameFilter = '';
    this.activityNameFilter = '';
    this.departmentFilter = '';

    // Clear old filter properties
    this.deptFilter = null;
    this.clientFilter = null;
    this.createdToFilter = null;
    this.craetedFromFilter = null;
    this.deviationSearch.reset();
    this.descFilter = null;
    this.responsibleFollowUpFilter = null;
    this.responsibleExecutionFilter = null;
    this.createdByFilter = null;
    this.statusDropdown = null;
    // Clear autocomplete filters
    this.selectedFollowUpPerson = null;
    this.selectedExecutionPerson = null;
    this.filteredFollowUpPersons = [];
    this.filteredExecutionPersons = [];

    // Clear date filters
    this.startDate = null;
    this.endDate = null;

    // Reset filter DTO
    this.deviationFilterDto = {};

    // Reset selected filters
    this.selectedFilters = {
      topic: null,
      case: null,
      followUp: null,
      execution: null,
      department: null,
      subDepartment: null
    };

    // Reset pagination
    this.paginationRequest.pageNumber = 1;

    // Clear sorting as well
    this.clearSorting();

    // Clear selections
    this.clearAllSelections();

    if (this.deviationTable) {
      this.deviationTable.reset();
    }

    // Manually clear all dropdown components
    this.clearDropdownComponents();

    this.bindDeviationList(false);
  }

  /**
   * Manually clear all dropdown components to reset their UI state
   */
  private clearDropdownComponents(): void {
    // Use setTimeout to ensure dropdowns are cleared after Angular change detection
    setTimeout(() => {
      // Clear Show Deviation dropdown
      if (this.showDeviationDropdown) {
        this.showDeviationDropdown.value = null;
        this.showDeviationDropdown.selectedOption = null;
        this.showDeviationDropdown.cd.detectChanges();
      }

      // Clear Case dropdown
      if (this.caseDropdown) {
        this.caseDropdown.value = null;
        this.caseDropdown.selectedOption = null;
        this.caseDropdown.cd.detectChanges();
      }

      // Clear Topics dropdown
      if (this.topicDropdown) {
        this.topicDropdown.value = null;
        this.topicDropdown.selectedOption = null;
        this.topicDropdown.cd.detectChanges();
      }

      // Clear Sub-department dropdown
      if (this.subDepControl) {
        this.subDepControl.value = null;
        this.subDepControl.selectedOption = null;
        this.subDepControl.cd.detectChanges();
      }

      // Clear Importance dropdown
      if (this.impControl) {
        this.impControl.value = null;
        this.impControl.selectedOption = null;
        this.impControl.cd.detectChanges();
      }

      // Clear Department dropdown
      if (this.depControl) {
        this.depControl.value = null;
        this.depControl.selectedOption = null;
        this.depControl.cd.detectChanges();
      }

      // Clear Modules dropdown
      if (this.modulesDropdown) {
        this.modulesDropdown.value = null;
        this.modulesDropdown.selectedOption = null;
        this.modulesDropdown.cd.detectChanges();
      }

      // Clear Status dropdown
      if (this.statusDropdown) {
        this.statusDropdown.value = null;
        this.statusDropdown.selectedOption = null;
        this.statusDropdown.cd.detectChanges();
      }

      // Clear Created By dropdown
      if (this.createdByDropdown) {
        this.createdByDropdown.value = null;
        this.createdByDropdown.selectedOption = null;
        this.createdByDropdown.cd.detectChanges();
      }

      // Clear Client dropdown
      if (this.clientDropdown) {
        this.clientDropdown.value = null;
        this.clientDropdown.selectedOption = null;
        this.clientDropdown.cd.detectChanges();
      }

      // Clear Status dropdown
      if (this.statusDropdown) {
        this.statusDropdown.value = null;
        this.statusDropdown.selectedOption = null;
        this.statusDropdown.cd.detectChanges();
      }
    }, 0);
  }

  /**
   * topic popup reset
   */
  onBeforeDeviationTopicDialogHide() {
    this.topicForm.reset();
  }

  /**
   * type of case popup reset
   */
  onBeforeDeviationTypeofCaseDialogHide() {
    this.caseForm.reset();
  }

  //#endregion

  //#region methods
  /**
   * bind deviation list by User Id
   */
  bindDeviationByUser() {
    if (
      BaseServices.UserRole == 'User' ||
      BaseServices.UserRole == 'Guest' ||
      BaseServices.UserRole == 'Editor'
    ) {
      this.deviationList = [];
      this.showLoader = true;

      this.subscriptions.push(
        this.deviationService
          .getDeviationListPagedByBusinessId(
            BaseServices.ApplicationId,
            this.paginationRequest,
            BaseServices.BusinessId,
            this.deviationFilterDto
          )
          .subscribe((response: PagedResponse<DeviationListDto>) => {
            this.handleDeviationResponse(response);
          })
      );
    }
  }
  /**
   *
   * bind status icon by status
   * @param deviations {any}
   */
  bindStatusIcon(deviations: any) {
    this.deviationList = [];
    if (deviations) {
      deviations.forEach((deviationInfo: any) => {
        let daysDiff = 0;
        let statusIcon = '';
        let currentdate = new Date();
        let deadLine = new Date(deviationInfo.Deadline);
        deviationInfo.Importance = this.assignRiskData(
          deviationInfo.Importance
        );
        if (deviationInfo.Deadline != null) {
          daysDiff = HelperService.getDaysDiff(currentdate, deadLine);
        }
        if (deviationInfo.StatusId === 9) {
          statusIcon = 'icon ic-sm icon-clear-deadline';
        } else if (deviationInfo.StatusId === 10) {
          statusIcon = 'icon ic-sm icon-cancel';
        } else if (deviationInfo.StatusId === 7) {
          statusIcon = 'icon ic-sm icon-new-deadline';
        } else if (deviationInfo.Deadline) {
          if (daysDiff > 3) {
            statusIcon = 'icon ic-sm icon-far-deadline';
          } else if (daysDiff > -1 && daysDiff < 4) {
            statusIcon = 'icon ic-sm icon-near-deadline';
          } else {
            statusIcon = 'icon ic-sm icon-over-deadline';
          }
        } else {
          statusIcon = 'icon ic-sm icon-over-deadline';
        }
        if (
          +deviationInfo.ClientId === FeatureKey.FOOD_SAFETY &&
          Number(sessionStorage.getItem('languageId')) === LanguageId.Norwegian
        ) {
          deviationInfo.Modules = deviationInfo.Modules.replace('FS', 'IK-Mat');
        }
        deviationInfo.StatusIcon = statusIcon;
        if (this.isAdminRightsForUser || this.isViewRightsForUser) {
          deviationInfo.Responsible = true;
        } else {
          deviationInfo.Responsible =
            deviationInfo.FollowUpUserId === BaseServices.UserId ||
            deviationInfo.ExecutionUserId === BaseServices.UserId ||
            deviationInfo.CreatedBy === BaseServices.UserId;
        }
        this.deviationList.push(deviationInfo);
        this.rowsPerPageOptions = [10, 20, 50, 100];
        if (this.totalRecords > 100) {
          this.rowsPerPageOptions.push(this.totalRecords);
        }
      });
    }
  }

  bindDeviationList(showInitialLoader: boolean = false) {
    if (showInitialLoader) {
      this.showLoader = true;
    }

    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const applicationId = BaseServices.ApplicationId || 0;
    const userId = BaseServices.UserId || 0;
    const isPortalManager = BaseServices.PortalManager || false;
    const businessId = BaseServices.BusinessId || 0;
    const portalId = BaseServices.PortalId || 0;
    this.portalId = portalId;

    this.validateSorting();

    let dataObservable: Observable<PagedResponse<DeviationListDto>>;

    if (this.isAdmin) {
      dataObservable = this.deviationService.getDeviationListPagedAdmin(
        this.paginationRequest,
        this.deviationFilterDto
      );
    } else if (this.isPortal) {
      dataObservable = this.deviationService.portalDeviationPagedList(
        portalId,
        userId,
        isPortalManager,
        applicationId,
        this.paginationRequest,
        this.deviationFilterDto
      );
    } else if (
      this.isEditor ||
      this.isAdminRightsForUser ||
      this.isViewRightsForUser
    ) {
      dataObservable = this.deviationService.getDeviationListPagedByBusinessId(
        applicationId,
        this.paginationRequest,
        businessId,
        this.deviationFilterDto
      );
    } else {
      this.deviationFilterDto.myOwnDeviation = this.isShowDeptDeviation
        ? true
        : false;
      this.deviationFilterDto.userId = BaseServices.UserId;
      dataObservable = this.deviationService.getDeviationListPagedByBusinessId(
        applicationId,
        this.paginationRequest,
        businessId,
        this.deviationFilterDto
      );
    }

    this.isLoadingData = true;

    const shouldLoadSubModules = !this.isAdmin && !this.isPortal;

    if (shouldLoadSubModules && this.subModuleLookup.size === 0) {
      const subModules$ = this.deviationService.getModulesByDeviation(
        BaseServices.BusinessId
      );

      this.loadingSubscription = forkJoin({
        deviations: dataObservable,
        subModules: subModules$
      }).subscribe(
        ({ deviations, subModules }) => {
          this.createSubModuleLookup(subModules);
          this.handleDeviationResponseWithSubModules(deviations);

          // Save filter state after successful load
          this.saveFilterStateToStorage();

          this.isLoadingData = false;
          if (showInitialLoader) {
            this.showLoader = false;
          }
        },
        error => {
          this.isLoadingData = false;
          if (showInitialLoader) {
            this.showLoader = false;
          }
        }
      );
    } else {
      this.loadingSubscription = dataObservable.subscribe(
        (response: PagedResponse<DeviationListDto>) => {
          if (shouldLoadSubModules) {
            this.handleDeviationResponseWithSubModules(response);
          } else {
            this.handleDeviationResponse(response);
          }

          // Save filter state after successful load
          this.saveFilterStateToStorage();

          this.isLoadingData = false;
          if (showInitialLoader) {
            this.showLoader = false;
          }
        },
        error => {
          this.isLoadingData = false;
          if (showInitialLoader) {
            this.showLoader = false;
          }
        }
      );
    }
  }

  private handleDeviationResponseWithSubModules(
    response: PagedResponse<DeviationListDto>
  ) {
    if (response != null && response.Succeeded) {
      const processedList: DeviationListDto[] = response.Items;

      this.applySubModuleMapping(processedList);

      this.applyStatusIconsToList(processedList);

      this.deviationList = processedList;
      this.totalRecords = response.TotalCount;
      this.totalPages = response.TotalPages;
      this.paginationRequest.pageNumber = response.PageNumber;
      this.paginationRequest.pageSize = response.PageSize;

      if (Boolean(response.Metadata)) {
        this.deviationListMetadata = response.Metadata;
      } else {
        this.deviationListMetadata = null;
      }

      this.bindDropDowns(this.deviationList);

      if (this.deviationTable) {
        const firstIndex =
          (this.paginationRequest.pageNumber - 1) *
          this.paginationRequest.pageSize;
        this.deviationTable.first = firstIndex;
      }
    }
  }

  private applyStatusIconsToList(deviations: any[]) {
    if (deviations) {
      deviations.forEach((deviationInfo: any) => {
        let daysDiff = 0;
        let statusIcon = '';
        let currentdate = new Date();
        let deadLine = new Date(deviationInfo.Deadline);

        deviationInfo.Importance = this.assignRiskData(
          deviationInfo.Importance
        );

        if (deviationInfo.Deadline != null) {
          daysDiff = HelperService.getDaysDiff(currentdate, deadLine);
        }

        if (deviationInfo.StatusId === 9) {
          statusIcon = 'icon ic-sm icon-clear-deadline';
        } else if (deviationInfo.StatusId === 10) {
          statusIcon = 'icon ic-sm icon-cancel';
        } else if (deviationInfo.StatusId === 7) {
          statusIcon = 'icon ic-sm icon-new-deadline';
        } else if (deviationInfo.Deadline) {
          if (daysDiff > 3) {
            statusIcon = 'icon ic-sm icon-far-deadline';
          } else if (daysDiff > -1 && daysDiff < 4) {
            statusIcon = 'icon ic-sm icon-near-deadline';
          } else {
            statusIcon = 'icon ic-sm icon-over-deadline';
          }
        } else {
          statusIcon = 'icon ic-sm icon-over-deadline';
        }

        if (
          +deviationInfo.ClientId === FeatureKey.FOOD_SAFETY &&
          Number(sessionStorage.getItem('languageId')) === LanguageId.Norwegian
        ) {
          deviationInfo.Modules = deviationInfo.Modules.replace('FS', 'IK-Mat');
        }

        deviationInfo.StatusIcon = statusIcon;
      });
    }
  }

  /**
   * Handle the response from the deviation service
   */
  private handleDeviationResponse(response: PagedResponse<DeviationListDto>) {
    if (response != null && response.Succeeded) {
      const processedList: DeviationListDto[] = response.Items;

      this.applyStatusIconsToList(processedList);

      this.deviationList = processedList;
      this.totalRecords = response.TotalCount;
      this.totalPages = response.TotalPages;
      this.paginationRequest.pageNumber = response.PageNumber;
      this.paginationRequest.pageSize = response.PageSize;

      if (Boolean(response.Metadata)) {
        this.deviationListMetadata = response.Metadata;
      } else {
        this.deviationListMetadata = null;
      }
      this.bindDropDowns(this.deviationList);

      if (this.deviationTable) {
        const firstIndex =
          (this.paginationRequest.pageNumber - 1) *
          this.paginationRequest.pageSize;
        this.deviationTable.first = firstIndex;
      } else {
        return;
      }
    }
  }

  /**
   * color risk figure
   * @param riskFigure {any}
   */
  assignRiskData(riskFigure: any) {
    let riskData: any = [];
    if (riskFigure!.value) {
      return riskFigure;
    } else {
      if (riskFigure === 'Low') {
        riskData.id = 1;
        riskData.value = 'LOW';
        riskData.backColor = '#4ec55c';
      } else if (riskFigure === 'Medium') {
        riskData.id = 2;
        riskData.value = 'MEDIUM';
        riskData.backColor = '#f0ac19';
      } else if (riskFigure === 'High') {
        riskData.id = 3;
        riskData.value = 'HIGH';
        riskData.backColor = '#e7644f';
      } else {
        riskData.backColor = '';
      }
      return riskData;
    }
  }

  /**
   * delete deviation
   * @param id {any}
   */
  confirm(id: any) {
    this.confirmationService.confirm({
      message: this.translate.instant('DELETE_THIS_RECORD'),
      accept: () => {
        this.deviationService
          .deleteDeviation(id)
          .then(() => {
            this.deviationList = this.deviationList.filter(
              (deviation: DeviationListDto) => deviation.Id !== id
            );
            this.notifications.success('UI_NOTIFICATIONS.DELETED');
          })
          .catch(error => {
            this.notifications.success('UI_NOTIFICATIONS.DELETED');
          });
      }
    });
  }

  /**
   * Confirm multi-delete action
   */
  confirmMultiDelete() {
    this.confirmationService.confirm({
      message: this.translate.instant('CONFIRM_MULTI_DELETE_DEVIATIONS'),
      accept: () => {
        this.multiDeleteDeviations();
      }
    });
  }

  /**
   * Delete multiple deviations
   */
  multiDeleteDeviations() {
    const deviationIds = Array.from(this.allSelectedDeviations);

    this.totalDeviationsToDelete = deviationIds.length;
    this.initialEstimatedTime = this.totalDeviationsToDelete * 0.5; // 0.5 seconds per deviation
    this.estimatedTimeRemaining = this.initialEstimatedTime;
    this.deletingProgress = 0;
    this.isDeletingDeviations = true;

    this.progressLoaderConfig = {
      isVisible: true,
      title: this.translate.instant('DELETING_DEVIATIONS'),
      message:
        this.translate.instant('DONT_CLOSE_PAGE') +
        ' ' +
        this.translate.instant('DELETING_DEVIATIONS'),
      progress: 0,
      totalItems: this.totalDeviationsToDelete,
      estimatedTimeRemaining: this.estimatedTimeRemaining,
      initialEstimatedTime: this.initialEstimatedTime,
      showProgressBar: true,
      showTimeRemaining: true,
      showItemCount: true
    };

    this.deviationService.multiDeleteDeviations(deviationIds).subscribe({
      next: (result: MultiDeleteResultDto) => {
        this.isDeletingDeviations = false;
        this.deletingProgress = 100;
        // Complete the progress bar smoothly instead of just hiding
        this.completeProgressSmoothly();
        if (result.Deleted?.length !== deviationIds.length ||
            result.NotFound?.length || Object.keys(result.Errors ?? {}).length) {
          this.notifications.warn('UI_NOTIFICATIONS.BULK_INCOMPLETE');
        } else {
          this.notifications.success('UI_NOTIFICATIONS.DELETED');
        }
        this.clearAllSelections();
        this.bindDeviationList(false);
      },
      error: error => {
        this.isDeletingDeviations = false;
        this.progressLoaderConfig.isVisible = false;
        
      }
    });
  }

  /**
   * Get formatted time remaining for deletion progress
   */
  getFormattedDeletingTimeRemaining(): string {
    if (this.initialEstimatedTime < 60) {
      return (
        Math.ceil(this.initialEstimatedTime) +
        ' ' +
        this.translate.instant('SECONDS')
      );
    } else {
      const minutes = Math.floor(this.initialEstimatedTime / 60);
      const seconds = Math.ceil(this.initialEstimatedTime % 60);
      return (
        minutes +
        ' ' +
        this.translate.instant('MINUTES') +
        (minutes > 1 ? 's' : '') +
        ' ' +
        seconds +
        ' ' +
        this.translate.instant('SECONDS') +
        (seconds > 1 ? 's' : '')
      );
    }
  }

  /**
   * bind dropdowns
   */
  bindDropDowns(deviations: any) {
    this.followup = [];
    let followUpPerson: any[];
    if (this.isAdmin == true) {
      followUpPerson = this.route.snapshot.data['deviationuser'];
    } else {
      followUpPerson = this.route.snapshot.data['user'];
    }
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.followup = [];
        this.followup.push({ label: val.SELECT, value: null });
        if (followUpPerson) {
          followUpPerson.forEach((followupPerson: any) => {
            this.followup.push({
              label: followupPerson.Name,
              value: followupPerson.Id
            });
          });
        }
      })
    );

    this.subscriptions.push(
      this.translate.stream('SELECT_STATUSES').subscribe(val => {
        this.statuses = [];
        this.statuses.push(
          { label: val.SELECT, value: null },
          { label: val.NEW, value: 7 },
          { label: val.OPEN, value: 8 },
          { label: val.DONE, value: 9 },
          { label: val.REJECTED, value: 10 }
        );
      })
    );

    this.Case = [];
    this.editTypeOfCases = [];
    let caseType: any[];
    caseType = this.route.snapshot.data['caseType'];
    const uniquecaseTypeSet = new Map<number, any>();

    caseType.forEach(item => {
      if (!uniquecaseTypeSet.has(item.Id)) {
        uniquecaseTypeSet.set(item.Id, item);
      }
    });
    const uniquecaseType = Array.from(uniquecaseTypeSet.values());

    if (BaseServices.roleId != '2') {
      this.subscriptions.push(
        this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
          this.Case = [];
          this.Case.push({ label: val.SELECT, value: null });
          if (caseType) {
            caseType.forEach((caseInfo: any) => {
              this.Case.push({ label: caseInfo.Name, value: caseInfo.Id });
              this.editTypeOfCases.push({
                Name: caseInfo.Name,
                Id: caseInfo.Id,
                IsDefault: caseInfo.IsDefault
              });
            });
          }
        })
      );
    } else {
      this.subscriptions.push(
        this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
          this.Case = [];
          this.Case.push({ label: val.SELECT, value: null });
          if (uniquecaseType) {
            uniquecaseType.forEach((caseInfo: any) => {
              this.Case.push({ label: caseInfo.Name, value: caseInfo.Id });
              this.editTypeOfCases.push({
                Name: caseInfo.Name,
                Id: caseInfo.Id,
                IsDefault: caseInfo.IsDefault
              });
            });
          }
        })
      );
    }

    this.Client = [];
    let clients = this.route.snapshot.data['client'];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.Client = [];
        this.Client.push({ label: val.SELECT, value: null });
        if (clients) {
          clients.forEach((clientInfo: any) => {
            this.Client.push({
              label: clientInfo.Name,
              value: clientInfo.Id
            });
          });
        }
      })
    );
    this.businesses = [];
    let business = this.route.snapshot.data['business'];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.businesses.push({ label: val.SELECT, value: null });
      })
    );
    if (business) {
      business.forEach((businessInfo: any) => {
        this.businesses.push({
          label: businessInfo.Name,
          value: businessInfo.Id
        });
      });
    }

    this.Topics = [];
    this.editTopics = [];
    let topics: any[];

    topics = this.route.snapshot.data['topic'];
    const uniquecaseTopicSet = new Map<number, any>();

    if (!this.isAdmin) {
      topics.forEach(item => {
        if (!uniquecaseTopicSet.has(item.Id)) {
          uniquecaseTopicSet.set(item.Id, item);
        }
      });
    }

    const uniquecaseTopic = Array.from(uniquecaseTopicSet.values());

    if (BaseServices.roleId != '2') {
      this.subscriptions.push(
        this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
          this.Topics = [];
          this.Topics.push({ label: val.SELECT, value: null });
          if (topics) {
            topics.forEach((topicInfo: any) => {
              this.Topics.push({
                label: topicInfo.Name,
                value: topicInfo.Id
              });
              this.editTopics.push({
                Name: topicInfo.Name,
                Id: topicInfo.Id
              });
            });
          }
        })
      );
    } else {
      this.subscriptions.push(
        this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
          this.Topics = [];
          this.Topics.push({ label: val.SELECT, value: null });
          if (uniquecaseTopic) {
            uniquecaseTopic.forEach((topicInfo: any) => {
              this.Topics.push({
                label: topicInfo.Name,
                value: topicInfo.Id
              });
              this.editTopics.push({
                Name: topicInfo.Name,
                Id: topicInfo.Id
              });
            });
          }
        })
      );
    }

    this.subscriptions.push(
      this.translate.stream('SELECT_DEVIATIONDROP').subscribe(val => {
        this.ShowDeviation = [];

        let userRightsId = Rights.ADMINISTRATE_DEVIATION;
        let role = BaseServices.UserRole;
        if (role === 'Editor') {
          this.ShowDeviation.push(
            { label: val.ALL_DEVIATION, value: '1' },
            { label: val.MY_DEVIATION, value: '2' }
          );
        } else if (role === 'User') {
          this.showDeviationDrop = BaseServices.checkUserRights(
            userRightsId,
            role
          );
          if (this.showDeviationDrop) {
            this.ShowDeviation.push(
              { label: val.ALL_DEVIATION, value: '1' },
              { label: val.MY_DEVIATION, value: '2' }
            );
          } else {
            let currentUserRole = BaseServices.UserRole;
            let userRightsId = Rights.VIEW_DEVIATION;
            let IsViewDeviation = BaseServices.checkUserRights(
              userRightsId,
              currentUserRole
            );
            let currentUserRole2 = BaseServices.UserRole;
            let userRightsId2 = Rights.SEE_ONLY_DEVIATION_IN_OWN_DEPT;
            let IsSeeOnlyDepartViewDev = BaseServices.checkUserRights(
              userRightsId2,
              currentUserRole2
            );
            if (IsViewDeviation) {
              this.ShowDeviation.push(
                { label: val.ALL_DEVIATION, value: '1' },
                { label: val.MY_DEVIATION, value: '2' }
              );
            } else if (IsSeeOnlyDepartViewDev) {
              this.ShowDeviation.push(
                { label: val.ALL_DEVIATION, value: '1' },
                { label: val.MY_DEVIATION, value: '2' }
              );
            } else {
              this.showDeviationDisabled = true;
              this.ShowDeviation.push({ label: val.MY_DEVIATION, value: '2' });
            }
          }
        } else {
          this.showDeviationDisabled = true;
          this.ShowDeviation.push({ label: val.MY_DEVIATION, value: '2' });
          this.bindDeviationByUser();
        }
      })
    );
    this.setDoneStatus(deviations);
  }

  setDoneStatus(deviations: any) {
    if (deviations) {
      deviations.forEach((e: any) => {
        if (e.StatusId === 9) {
          this.isStatusDone = false;
        } else {
          this.isStatusDone = true;
        }
      });
      this.deviationAllList = deviations;
      this.bindStatusIcon(deviations);
      this.getSum(deviations, 0, this.itemsPerPage);
    }
  }

  /**
   * bind type of case dropdown
   */
  bindTypeofCaseDropdown() {
    this.subscriptions.push(
      this.deviationService.getAllCaseType().subscribe(typeCaseList => {
        if (typeCaseList) {
          this.Case = [];
          typeCaseList.forEach((typeCase: any) => {
            this.Case.push({ label: typeCase.Name, value: typeCase.Id });
          });
        }
        this.editTypeOfCases = typeCaseList;
      })
    );
  }

  /**
   * bind topic dropdown
   */
  bindTopicDropdown() {
    let topicList = this.route.snapshot.data['topic'];
    if (topicList) {
      this.Topics = [];
      this.subscriptions.push(
        this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
          this.Topics = [];
          this.Topics.push({ label: val.SELECT, value: null });
        })
      );
      topicList.forEach((topic: any) => {
        this.Topics.push({
          label: topic.Name,
          value: topic.Id
        });
      });
      this.editTopics = topicList;
    }
  }

  deviationFilterChange(event: any) {
    let list = event.filteredValue;
    if (list && list.length > 0) {
      this.getSum(list, 0, this.itemsPerPage);
    }
  }

  onTextFilterChange(filterType: string, value: string) {
    if (this.isLoadingData) return;

    if (this.filterDebounceTimer) {
      clearTimeout(this.filterDebounceTimer);
    }

    this.filterDebounceTimer = setTimeout(() => {
      switch (filterType) {
        case 'no':
          this.noFilter = value;
          this.deviationFilterDto.no = value || undefined;
          break;
        case 'businessName':
          this.businessNameFilter = value;
          this.deviationFilterDto.businessName = value || undefined;
          break;
        case 'title':
          this.titleFilter = value;
          this.deviationFilterDto.title = value || undefined;
          break;
        case 'checklistName':
          this.checklistNameFilter = value;
          this.deviationFilterDto.checklistName = value || undefined;
          break;
        case 'activityName':
          this.activityNameFilter = value;
          this.deviationFilterDto.activityName = value || undefined;
          break;
        case 'department':
          this.departmentFilter = value;
          this.deviationFilterDto.department = value || undefined;
          break;
      }

      this.paginationRequest.pageNumber = 1;

      this.bindDeviationList(false);
    }, 500);
  }

  deviationPageChange(event: any) {
    const newPageNumber = Math.floor(event.first / event.rows) + 1;
    const newPageSize = event.rows;

    if (this.paginationDebounceTimerId) {
      clearTimeout(this.paginationDebounceTimerId);
    }

    this.paginationDebounceTimerId = setTimeout(() => {
      this.paginationRequest.pageNumber = newPageNumber;
      this.paginationRequest.pageSize = newPageSize;

      // Preserve existing sorting when changing pages
      this.validateSorting();

      this.bindDeviationList(false);

      this.paginationDebounceTimerId = null;
    }, this.PAGINATION_DEBOUNCE_TIME_MS);
  }

  /**
   * page wise cost calculation
   * @param deviations {DeviationList}
   * @param start {number}
   * @param end {number}
   */
  getSum(deviations: DeviationList[], start: number, end: number): void {
    deviations = _.slice(deviations, start, end);
    let sum = _.sumBy(deviations, o => {
      return o.Cost || 0;
    });
    this.pageSum = this.convertDecimal(sum);
  }

  convertDecimal(data: any) {
    if (data !== null) {
      if (data === 0) {
        return data.toFixed(2);
      } else {
        return data.toFixed(2);
      }
    }
  }

  /**
   * Edit the page based upon administrate deviation rights
   */
  onAdministrateDeviation() {
    let currentUserRole1 = BaseServices.UserRole;
    let userRightsIdAdmin = Rights.ADMINISTRATE_DEVIATION;
    let userRightsView = Rights.VIEW_DEVIATION;
    let userRightsViewDepart = Rights.SEE_ONLY_DEVIATION_IN_OWN_DEPT;

    if (currentUserRole1 === 'User') {
      let CheckAdmin = BaseServices.checkUserRights(
        userRightsIdAdmin,
        currentUserRole1
      );
      let CheckView = BaseServices.checkUserRights(
        userRightsView,
        currentUserRole1
      );
      let CheckViewDepart = BaseServices.checkUserRights(
        userRightsViewDepart,
        currentUserRole1
      );
      let userRightsId = Rights.SEE_ONLY_DEVIATION_IN_OWN_DEPT;
      this.isShowDeptDeviation = BaseServices.checkUserRights(
        userRightsId,
        currentUserRole1
      );
      this.isAdminRightsForUser = CheckAdmin;
      this.isViewRightsForUser = CheckView;
    }
    this.bindDeviationList();

    let currentUserRole = BaseServices.UserRole;
    let userRightsId = Rights.ADMINISTRATE_DEVIATION;
    if (currentUserRole === 'User' || currentUserRole === 'Guest') {
      this.hasDeviationDeleteAccess = false;
      this.isStatusDone = false;
      this.isShowSaveButton = BaseServices.checkUserRights(
        userRightsId,
        currentUserRole
      );
      if (this.isShowSaveButton === false) {
        this.displayDeviation = true;
        if (currentUserRole === 'Guest') {
          this.onDeviationRights();
        } else {
          this.newButtonDisplay = false;
        }
        this.onViewDeviation();
      } else if (this.isShowSaveButton) {
        this.hasDeviationDeleteAccess = true;
        this.bindDeviationList();
      }
    }
  }

  /**
   * update deviation based on viewdeviation rights
   */
  onViewDeviation() {
    let currentUserRole = BaseServices.UserRole;
    let userRightsId = Rights.VIEW_DEVIATION;
    if (currentUserRole === 'User' || currentUserRole === 'Guest') {
      this.isShowSaveButton = BaseServices.checkUserRights(
        userRightsId,
        currentUserRole
      );
      if (this.isShowSaveButton) {
        this.showDeviationDisabled = false;
        this.bindDeviationList();
      }
    }
  }

  /**
   * add deviation based on the deviation rights
   */
  onDeviationRights() {
    let userRightsId = Rights.DEVIATION_RIGHTS;
    let role = BaseServices.UserRole;
    if (role === 'Guest') {
      this.newButtonDisplay = BaseServices.checkUserRights(userRightsId, role);
      if (this.newButtonDisplay === true) {
        this.isShowNewButton = true;
      } else {
        this.isShowNewButton = false;
      }
    }
  }

  onShowCostColumnChange() {
    sessionStorage.setItem(
      'search_FollowupDev_ShowCost',
      this.showCostColumn ? '1' : ''
    );
  }

  onCreatedByChange(e: any, searchValue: any) {
    const selectedValue = e.value;

    sessionStorage.setItem('search_FollowupDev_CreatedBy', selectedValue || '');

    this.deviationFilterDto.createdBy = selectedValue || undefined;

    this.paginationRequest.pageNumber = 1;

    this.bindDeviationList();
  }

  /**
   * Show loading bar when export the data.
   */
  loader(value: any) {
    this.Showloader = value;
  }

  private startChartCycling() {
    setInterval(() => {
      if (!this.isPaused) {
        this.currentIndex = (this.currentIndex + 1) % this.chartViews.length;
        this.chartView = this.chartViews[this.currentIndex];
      }
    }, 8000);
  }

  togglePause() {
    this.isPaused = !this.isPaused;
  }

  changeChart(direction: 'next' | 'previous') {
    this.isPaused = true;

    if (direction === 'next') {
      this.currentIndex = (this.currentIndex + 1) % this.chartViews.length;
    } else if (direction === 'previous') {
      this.currentIndex =
        (this.currentIndex - 1 + this.chartViews.length) %
        this.chartViews.length;
    }
    this.chartView = this.chartViews[this.currentIndex];
  }

  onChildButtonClicked() {
    this.isPaused = true;
  }

  get chartView(): string {
    return this.chartViews[this.currentIndex];
  }

  set chartView(value: string) {
    this.currentIndex = this.chartViews.indexOf(value);
  }

  onFollowupChanged(followUpDropdown: Select) {
    const selectedValue = followUpDropdown.value;

    sessionStorage.setItem(
      'search_FollowupDev_ResponsibleForFollowup',
      selectedValue || ''
    );

    this.selectedFilters.followUp = selectedValue;

    this.deviationFilterDto.followUpUserId = selectedValue || undefined;

    this.paginationRequest.pageNumber = 1;

    this.bindDeviationList();
  }

  onExecutionChanged(executionDropdown: Select) {
    const selectedValue = executionDropdown.selectedOption?.value || null;

    sessionStorage.setItem(
      'search_FollowupDev_ResponsibleForExecution',
      selectedValue || ''
    );

    this.selectedFilters.execution = selectedValue;

    this.deviationFilterDto.executionUserId = selectedValue || undefined;

    this.paginationRequest.pageNumber = 1;

    this.bindDeviationList();
  }

  onDepartmentChangeId(e: any, departmentDropdown: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = e.value;
    this.deviationFilterDto.department = selectedValue || undefined;
    this.paginationRequest.pageNumber = 1;
    this.bindDeviationList(false);
  }

  onDepartmentChangedName(depControl: Select) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = depControl.value;
    const selectedLabel =
      depControl.label() === 'Select' ? undefined : depControl.label();

    const departmentName =
      selectedValue && selectedLabel && selectedLabel !== 'Select'
        ? selectedLabel
        : undefined;

    sessionStorage.setItem('search_FollowupDev_Dept', selectedLabel || '');

    this.selectedFilters.department = departmentName;

    this.deviationFilterDto.department = departmentName;

    this.paginationRequest.pageNumber = 1;

    if (selectedValue) {
      this.bindSubDepartmentDropdown(selectedValue);
    } else {
      this.subDepartments = [];
      this.selectedFilters.subDepartment = null;
      this.deviationFilterDto.subDepartmentId = undefined;
    }

    this.bindDeviationList(false);
  }

  onSubDepartmentChanged(subDepControl: Select) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }
    const selectedValue = subDepControl.value;

    sessionStorage.setItem('search_FollowupDev_SubDept', selectedValue || '');

    this.selectedFilters.subDepartment = selectedValue || null;

    this.deviationFilterDto.subDepartmentId = selectedValue || undefined;

    this.paginationRequest.pageNumber = 1;

    this.bindDeviationList(false);
  }

  /**
   * Handle NEW button click - show business selection for portal users
   */
  onNewButtonClick(): void {
    if (this.isPortal) {
      this.showBusinessSelectionDialog = true;
      this.blurService.enableBlur();
    } else {
      // For non-portal users, navigate directly
      this.router.navigate(['./new'], {
        relativeTo: this.route,
        state: { activatedFeatureIds: this.activatedFeatureIds }
      });
    }
  }

  /**
   * Handle business selection from dialog
   */
  onBusinessSelected(business: { name: string; id: number }): void {
    // Reset the dialog visibility
    this.showBusinessSelectionDialog = false;
    this.blurService.disableBlur();

    // Navigate to deviation creation page with business ID and name as query parameters
    this.router.navigate(['./new-portal-deviation'], {
      relativeTo: this.route,
      queryParams: {
        Id: business.id,
        Name: business.name
      }
    });
  }

  /**
   * Handle business selection cancellation
   */
  onBusinessSelectionCancelled(): void {
    // Reset the dialog visibility to ensure it can be opened again
    this.showBusinessSelectionDialog = false;
    this.blurService.disableBlur();
  }

  /**
   * Handle dialog visibility changes (when closed by clicking outside or X button)
   */
  onBusinessDialogVisibilityChange(visible: boolean): void {
    if (!visible) {
      // Dialog is being closed, reset the visibility state
      this.showBusinessSelectionDialog = false;
      this.blurService.disableBlur();
    }
  }

  /**
   * Complete the progress bar smoothly to 100% and then hide
   */
  completeProgressSmoothly(): void {
    if (this.progressLoader && this.progressLoader.completeProgress) {
      this.progressLoader.completeProgress();
    } else {
      // Fallback: just hide immediately if component reference is not available
      this.progressLoaderConfig.isVisible = false;
    }
  }

  /**
   * Toggle filter visibility
   */
  toggleFilters(): void {
    this.showFilters = !this.showFilters;
  }

  //#endregion

  //#region QR Code Manager

  showQrGeneratorDialog: boolean = false;
  qrCodeData?: DeviationQrCodeDto = null;
  isQrCodeLoading: boolean = false;

  /**
   * Handle Manage QR Code button click - fetch existing QR code data and show dialog
   */
  onManageQrCodeClick() {
    this.isQrCodeLoading = true;
    this.subscriptions.push(
      this.deviationService
        .getDeviationFollowUpQrCode()
        .pipe(
          finalize(() => {
            this.isQrCodeLoading = false;
          })
        )
        .subscribe({
          next: (qrCodeData: DeviationQrCodeDto) => {
            this.qrCodeData = qrCodeData;
          }
        })
    );
    this.showQrGeneratorDialog = true;
  }

  /**
   * Handle QR code creation with optional expiration date
   * @param expirationDate Expiration date for the QR code, or null for no expiration
   */
  onCreateQrCode(expirationDate: string | null) {
    this.isQrCodeLoading = true;
    this.subscriptions.push(
      this.deviationService
        .createDeviationFollowUpQrCode(expirationDate ?? null)
        .pipe(
          finalize(() => {
            this.isQrCodeLoading = false;
          })
        )
        .subscribe({
          next: (qrCodeData: DeviationQrCodeDto) => {
            this.qrCodeData = qrCodeData;
          }
        })
    );
  }

  /**
   * Handle QR code revocation
   */
  onRevokeQrCode() {
    this.isQrCodeLoading = true;
    this.subscriptions.push(
      this.deviationService
        .revokeDeviationFollowUpQrCode()
        .pipe(
          finalize(() => {
            this.isQrCodeLoading = false;
          })
        )
        .subscribe({
          next: () => {
            this.qrCodeData = null;
          }
        })
    );
  }

  //#endregion
}
